//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from "@angular/common/http";
import { Inject, Injectable, InjectionToken, Optional } from "@angular/core";
import { Observable, of as _observableOf, throwError as _observableThrow } from "rxjs";
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from "rxjs/operators";

export const API_BASE_URL = new InjectionToken<string>("API_BASE_URL");

@Injectable()
export class Client {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl ?? "/api";
  }

  /**
   * Get latest application version
   * @return OK
   */
  getLatestApplicationVersion(): Observable<ApplicationVersionResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/application-version/latest";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestApplicationVersion(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestApplicationVersion(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApplicationVersionResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ApplicationVersionResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processGetLatestApplicationVersion(response: HttpResponseBase): Observable<ApplicationVersionResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApplicationVersionResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Not Found", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Set application version
   * @param body (optional)
   * @return OK
   */
  setApplicationVersion(body: ApplicationVersionRequestModel | undefined): Observable<ApplicationVersionResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/application-version";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetApplicationVersion(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetApplicationVersion(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApplicationVersionResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ApplicationVersionResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processSetApplicationVersion(response: HttpResponseBase): Observable<ApplicationVersionResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ApplicationVersionResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Bad Request", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Forbidden", status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Downloads an attachment by its id, using attachmentName and fileExtension
    to construct the final filename (e.g. `MyDocument.pdf`) and resolve the correct MIME type.
    Streams the file directly when the Search API serves it inline (HTTP 200),
    or redirects the client to the pre-signed URL when the API answers with a redirect (HTTP 302).
     * @param id Unique identifier of the attachment. Must be a positive integer.
     * @param attachmentName File name without extension (e.g. `MyDocument`). Combined with fileExtension to form the download filename.
     * @param fileExtension File extension with or without leading dot (e.g. `pdf` or `.pdf`). Used to resolve the MIME type and append to the filename.
     * @return File content streamed inline with resolved filename and content type.
     */
  download(id: number, attachmentName: string, fileExtension: string): Observable<FileResponse> {
    let url_ = this.baseUrl + "/attachment/download/{id}?";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (attachmentName === undefined || attachmentName === null)
      throw new globalThis.Error("The parameter 'attachmentName' must be defined and cannot be null.");
    else url_ += "attachmentName=" + encodeURIComponent("" + attachmentName) + "&";
    if (fileExtension === undefined || fileExtension === null)
      throw new globalThis.Error("The parameter 'fileExtension' must be defined and cannot be null.");
    else url_ += "fileExtension=" + encodeURIComponent("" + fileExtension) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownload(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownload(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
    } else if (status === 302) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("Redirects to the pre-signed download URL from the Search API.", status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If attachmentName or fileExtension is missing, or id is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Missing or invalid authentication token.", status, _responseText, _headers, result401);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("No attachment found with the given id.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("The downstream Search API returned an unexpected response.", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get dropdown values for a specified language.
   * @param language EN (only english available for now)
   * @return Returns the list of dropdown values.
   */
  dropdownValues(language: string): Observable<DropdownValuesResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/dropdown-values?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDropdownValues(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDropdownValues(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DropdownValuesResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<DropdownValuesResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processDropdownValues(response: HttpResponseBase): Observable<DropdownValuesResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DropdownValuesResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Search for errors with pagination support.
   * @param errorId (optional)
   * @param type (optional)
   * @param objectId (optional)
   * @param objectType (optional)
   * @param dataSource (optional)
   * @param producer (optional)
   * @param ingestId (optional)
   * @param eventId (optional)
   * @param isResolved (optional)
   * @param isDeprecated (optional)
   * @param maintenanceGroup (optional)
   * @param elements (optional)
   * @param offset (optional)
   * @return Returns the paginated list of errors.
   */
  searchErrors(
    errorId: string | undefined,
    type: ErrorTypeId[] | undefined,
    objectId: string | undefined,
    objectType: ErrorObjectTypeId | undefined,
    dataSource: string | undefined,
    producer: ErrorObjectProducerId | undefined,
    ingestId: string | undefined,
    eventId: string | undefined,
    isResolved: boolean | undefined,
    isDeprecated: boolean | undefined,
    maintenanceGroup: string | undefined,
    elements: number | undefined,
    offset: number | undefined
  ): Observable<ErrorCorrectionResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/errors?";
    if (errorId === null) throw new globalThis.Error("The parameter 'errorId' cannot be null.");
    else if (errorId !== undefined) url_ += "ErrorId=" + encodeURIComponent("" + errorId) + "&";
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined)
      type &&
        type.forEach((item) => {
          url_ += "Type=" + encodeURIComponent("" + item) + "&";
        });
    if (objectId === null) throw new globalThis.Error("The parameter 'objectId' cannot be null.");
    else if (objectId !== undefined) url_ += "ObjectId=" + encodeURIComponent("" + objectId) + "&";
    if (objectType === null) throw new globalThis.Error("The parameter 'objectType' cannot be null.");
    else if (objectType !== undefined) url_ += "ObjectType=" + encodeURIComponent("" + objectType) + "&";
    if (dataSource === null) throw new globalThis.Error("The parameter 'dataSource' cannot be null.");
    else if (dataSource !== undefined) url_ += "DataSource=" + encodeURIComponent("" + dataSource) + "&";
    if (producer === null) throw new globalThis.Error("The parameter 'producer' cannot be null.");
    else if (producer !== undefined) url_ += "Producer=" + encodeURIComponent("" + producer) + "&";
    if (ingestId === null) throw new globalThis.Error("The parameter 'ingestId' cannot be null.");
    else if (ingestId !== undefined) url_ += "IngestId=" + encodeURIComponent("" + ingestId) + "&";
    if (eventId === null) throw new globalThis.Error("The parameter 'eventId' cannot be null.");
    else if (eventId !== undefined) url_ += "EventId=" + encodeURIComponent("" + eventId) + "&";
    if (isResolved === null) throw new globalThis.Error("The parameter 'isResolved' cannot be null.");
    else if (isResolved !== undefined) url_ += "IsResolved=" + encodeURIComponent("" + isResolved) + "&";
    if (isDeprecated === null) throw new globalThis.Error("The parameter 'isDeprecated' cannot be null.");
    else if (isDeprecated !== undefined) url_ += "IsDeprecated=" + encodeURIComponent("" + isDeprecated) + "&";
    if (maintenanceGroup === null) throw new globalThis.Error("The parameter 'maintenanceGroup' cannot be null.");
    else if (maintenanceGroup !== undefined) url_ += "MaintenanceGroup=" + encodeURIComponent("" + maintenanceGroup) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "Elements=" + encodeURIComponent("" + elements) + "&";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchErrors(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchErrors(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ErrorCorrectionResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ErrorCorrectionResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processSearchErrors(response: HttpResponseBase): Observable<ErrorCorrectionResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorCorrectionResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the request parameters are invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Resolve a list of errors by their object IDs.
   * @param body (optional) Request body containing the list of object IDs (GUIDs) to resolve.
   * @return Returns the resolved and failed object ID lists.
   */
  resolveErrors(body: ResolveErrorsRequestModel | undefined): Observable<ResolveErrorsResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/errors/resolve";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResolveErrors(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResolveErrors(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResolveErrorsResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ResolveErrorsResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processResolveErrors(response: HttpResponseBase): Observable<ResolveErrorsResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ResolveErrorsResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the request body is invalid or the object ID list is empty.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException(
            "If the external Status API is unavailable or returns an unexpected error.",
            status,
            _responseText,
            _headers,
            result502
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get detailed information about a specific error by its ID.
   * @param errorId Unique identifier (GUID) of the error.
   * @return Returns the detailed error information.
   */
  getError(errorId: string): Observable<ErrorCorrectionDetailedResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/errors/{errorId}";
    if (errorId === undefined || errorId === null) throw new globalThis.Error("The parameter 'errorId' must be defined.");
    url_ = url_.replace("{errorId}", encodeURIComponent("" + errorId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetError(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetError(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ErrorCorrectionDetailedResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ErrorCorrectionDetailedResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processGetError(response: HttpResponseBase): Observable<ErrorCorrectionDetailedResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorCorrectionDetailedResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the `errorId` is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the error is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get error filters for the authenticated user.
   * @return Returns the list of error filters.
   */
  getErrorFilters(): Observable<ErrorFilterReponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/error-filters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetErrorFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetErrorFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ErrorFilterReponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ErrorFilterReponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processGetErrorFilters(response: HttpResponseBase): Observable<ErrorFilterReponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorFilterReponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If the request is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If no error filters are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new error filter for the authenticated user.
   * @param body (optional) Payload with the error filter configuration to be created.
   * @return Returns the created error filter.
   */
  createErrorFilter(body: CreateErrorFilterRequestModel | undefined): Observable<ErrorFilterReponseModel> {
    let url_ = this.baseUrl + "/error-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateErrorFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateErrorFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ErrorFilterReponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ErrorFilterReponseModel>;
        })
      );
  }

  protected processCreateErrorFilter(response: HttpResponseBase): Observable<ErrorFilterReponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorFilterReponseModel);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If the request is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If related resources are not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If a conflict occurs while creating the error filter.", status, _responseText, _headers, result409);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing error filter for the authenticated user.
   * @param body (optional) Payload with the updated error filter configuration.
   * @return Returns the updated error filter.
   */
  updateErrorFilters(body: UpdateErrorFilterRequestModel | undefined): Observable<ErrorFilterReponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/error-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateErrorFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateErrorFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ErrorFilterReponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ErrorFilterReponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateErrorFilters(response: HttpResponseBase): Observable<ErrorFilterReponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorFilterReponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If the request is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If the error filter is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("If a conflict occurs while updating the error filter.", status, _responseText, _headers, result409);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Delete an error filter for the authenticated user.
   * @param id Identifier of the error filter to delete.
   * @return No Content
   */
  deleteErrorFilter(id: number): Observable<void> {
    let url_ = this.baseUrl + "/error-filters/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({}),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteErrorFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteErrorFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteErrorFilter(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("Bad Request", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel[]);
          return throwException("Not Found", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Search facilities with filters and pagination.
   * @param body (optional) Request body containing filter criteria and pagination settings.
   * @return Returns the paginated facilities list.
   */
  searchFacilities(body: SearchFacilityRequestModel | undefined): Observable<FacilitySearchResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/facilities/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchFacilities(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchFacilities(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilitySearchResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilitySearchResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processSearchFacilities(response: HttpResponseBase): Observable<FacilitySearchResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FacilitySearchResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the provided request body is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get a facility details by its identifier.
   * @param id Facility identifier.
   * @return Returns the facility details.
   */
  facilities(id: number): Observable<FacilityResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facilities/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFacilities(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFacilities(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilityResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilityResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processFacilities(response: HttpResponseBase): Observable<FacilityResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FacilityResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the facility is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an unexpected error occurs.", status, _responseText, _headers, result500);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new facility.
   * @param body (optional) Request body with the facility data to be created.
   * @return Facility creation request accepted.
   */
  createFacility(body: CreateFacilityRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/facilities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFacility(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateFacility(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateFacility(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the request body fails validation.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an unexpected error occurs on the server.", status, _responseText, _headers, result500);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing facility.
   * @param body (optional) Request body with the facility data to update.
   * @return Facility update request accepted.
   */
  updateFacility(body: UpdateFacilityRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/facilities";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFacility(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFacility(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateFacility(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the request body fails validation.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If a downstream service error occurs.", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get facility filters based on provided query criteria.
   * @return Returns the list of filters.
   */
  facilityFilters(): Observable<FacilityFilterResponseModelIEnumerableBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facility-filters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFacilityFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFacilityFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilityFilterResponseModelIEnumerableBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilityFilterResponseModelIEnumerableBaseResultResponseModel>;
        })
      );
  }

  protected processFacilityFilters(response: HttpResponseBase): Observable<FacilityFilterResponseModelIEnumerableBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FacilityFilterResponseModelIEnumerableBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If the request is invalid.", status, _responseText, _headers);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no filters are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If there is an internal server error.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create new facility filters.
   * @param body (optional) The facility filter data.
   * @return Returns the created or updated filter.
   */
  addFacilityFilters(body: FacilityFilterRequestModel | undefined): Observable<FacilityFilterResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facility-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddFacilityFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddFacilityFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilityFilterResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilityFilterResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processAddFacilityFilters(response: HttpResponseBase): Observable<FacilityFilterResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FacilityFilterResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If there is a conflict with the existing data.", status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If there is an internal server error.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update existing facility filters.
   * @param body (optional) The facility filter data.
   * @return Returns the updated filter.
   */
  updateFacilityFilters(body: FacilityFilterRequestModel | undefined): Observable<FacilityFilterResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facility-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFacilityFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFacilityFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilityFilterResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilityFilterResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateFacilityFilters(response: HttpResponseBase): Observable<FacilityFilterResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FacilityFilterResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If there is a conflict with the existing data.", status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If there is an internal server error.", status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Delete facility filters by ID.
   * @param id The ID of the filter to delete.
   * @return If the filter is successfully deleted.
   */
  deleteFacilityFilter(id: number): Observable<DeleteResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facility-filters/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFacilityFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFacilityFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processDeleteFacilityFilter(response: HttpResponseBase): Observable<DeleteResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the filter is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If there is an internal server error.", status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve facility hierarchy nodes.
   * @param mainFacilityId The ID of the main facility.
   * @return Returns hierarchy data.
   */
  facilityHierarchies(mainFacilityId: number): Observable<FacilityHierarchyResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/facility-hierarchies/{mainFacilityId}";
    if (mainFacilityId === undefined || mainFacilityId === null) throw new globalThis.Error("The parameter 'mainFacilityId' must be defined.");
    url_ = url_.replace("{mainFacilityId}", encodeURIComponent("" + mainFacilityId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFacilityHierarchies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFacilityHierarchies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FacilityHierarchyResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<FacilityHierarchyResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processFacilityHierarchies(response: HttpResponseBase): Observable<FacilityHierarchyResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as FacilityHierarchyResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an error occurs while processing the request.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Search IBase objects.
   * @param body (optional) Search filter for IBase objects.
   * @return Returns matching IBase objects.
   */
  searchIBases(body: SearchIBaseRequestModel | undefined): Observable<SearchIBaseResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/ibases/search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchIBases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchIBases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SearchIBaseResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SearchIBaseResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processSearchIBases(response: HttpResponseBase): Observable<SearchIBaseResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SearchIBaseResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If request parameters are invalid.", status, _responseText, _headers);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get a specific IBase object by its ID.
   * @param id The ID of the IBase object.
   * @return Returns the requested IBase object.
   */
  ibases(id: number): Observable<IBaseResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibases/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIbases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIbases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processIbases(response: HttpResponseBase): Observable<IBaseResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no IBase object is found with the given ID.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Get a paginated list of the IBase's "further relations": parent asset collections
    (RelationType = Contained) followed by child IBases (RelationType = Contains),
    concatenated into a single paginated list. Maximum page size is 500.
     * @param id The ID of the IBase object.
     * @param offset (optional) Zero-based offset into the concatenated relations list.
     * @param elements (optional) Page size (1–500).
     * @return Returns the requested page of further relations.
     */
  getFurtherRelations(
    id: number,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/ibases/{id}/further-relations?";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFurtherRelations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFurtherRelations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processGetFurtherRelations(response: HttpResponseBase): Observable<IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If pagination parameters are invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no IBase object is found with the given ID.", status, _responseText, _headers, result404);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new IBase object.
   * @param body (optional) The data for the new IBase object.
   * @return IBase object created successfully.
   */
  createIBase(body: CreateIBaseRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/ibases";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateIBase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateIBase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCreateIBase(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the provided data is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an error occurs while processing the request.", status, _responseText, _headers, result500);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing IBase object.
   * @param body (optional) The updated data for the IBase object.
   * @return IBase object updated successfully.
   */
  updateIBase(body: UpdateIBaseRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/ibases";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateIBase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateIBase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUpdateIBase(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the provided data is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an error occurs while processing the request.", status, _responseText, _headers, result500);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Perform a complex search for IBase objects.
   * @param body (optional) The complex search parameters.
   * @return Returns the search results.
   */
  complexSearch(body: ComplexSearchIBaseRequestModel | undefined): Observable<ComplexSearchIBaseResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibases/complex-search";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processComplexSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processComplexSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ComplexSearchIBaseResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ComplexSearchIBaseResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processComplexSearch(response: HttpResponseBase): Observable<ComplexSearchIBaseResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ComplexSearchIBaseResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If the search parameters are invalid.", status, _responseText, _headers);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get filters for IBase entities.
   * @return Returns filters.
   */
  getIBaseFilters(): Observable<IBaseFilterResponseModelIEnumerableBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-filters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIBaseFilters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIBaseFilters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseFilterResponseModelIEnumerableBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseFilterResponseModelIEnumerableBaseResultResponseModel>;
        })
      );
  }

  protected processGetIBaseFilters(response: HttpResponseBase): Observable<IBaseFilterResponseModelIEnumerableBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseFilterResponseModelIEnumerableBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If the request is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no filters are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new IBase filter.
   * @param body (optional) The filter data.
   * @return Returns the created filter.
   */
  addIBaseFilter(body: IBaseFilterRequestModel | undefined): Observable<IBaseFilterResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddIBaseFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddIBaseFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseFilterResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseFilterResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processAddIBaseFilter(response: HttpResponseBase): Observable<IBaseFilterResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseFilterResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If a conflict occurs (e.g., duplicate key).", status, _responseText, _headers, result409);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing IBase filter.
   * @param body (optional) The updated filter data.
   * @return Returns the updated filter.
   */
  updateIBaseFilter(body: IBaseFilterRequestModel | undefined): Observable<IBaseFilterResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-filters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateIBaseFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateIBaseFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseFilterResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseFilterResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateIBaseFilter(response: HttpResponseBase): Observable<IBaseFilterResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseFilterResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If a conflict occurs (e.g., duplicate key).", status, _responseText, _headers, result409);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Delete an IBase filter.
   * @param id The ID of the filter to delete.
   * @return If the filter was successfully deleted.
   */
  deleteIBaseFilter(id: number): Observable<DeleteResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-filters/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteIBaseFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteIBaseFilter(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DeleteResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<DeleteResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processDeleteIBaseFilter(response: HttpResponseBase): Observable<DeleteResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the filter was not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve IBase hierarchy.
   * @param mainIBaseId The main IBase ID.
   * @return Returns hierarchy nodes.
   */
  ibaseHierarchies(mainIBaseId: number): Observable<IBaseHierarchyResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-hierarchies/{mainIBaseId}";
    if (mainIBaseId === undefined || mainIBaseId === null) throw new globalThis.Error("The parameter 'mainIBaseId' must be defined.");
    url_ = url_.replace("{mainIBaseId}", encodeURIComponent("" + mainIBaseId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIbaseHierarchies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIbaseHierarchies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseHierarchyResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseHierarchyResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processIbaseHierarchies(response: HttpResponseBase): Observable<IBaseHierarchyResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseHierarchyResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an error occurs while processing the request.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve IBase hierarchy descendants by parent IBase ID.
   * @param mainIBaseId The main IBase ID.
   * @param offset (optional) The number of records to skip.
   * @param elements (optional) The number of records to take.
   * @return Returns hierarchy descendant nodes.
   */
  descendants(
    mainIBaseId: number,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<IBaseHierarchyDescendantsResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ibase-hierarchies/{mainIBaseId}/descendants?";
    if (mainIBaseId === undefined || mainIBaseId === null) throw new globalThis.Error("The parameter 'mainIBaseId' must be defined.");
    url_ = url_.replace("{mainIBaseId}", encodeURIComponent("" + mainIBaseId));
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDescendants(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDescendants(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IBaseHierarchyDescendantsResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IBaseHierarchyDescendantsResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processDescendants(response: HttpResponseBase): Observable<IBaseHierarchyDescendantsResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IBaseHierarchyDescendantsResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If an error occurs while processing the request.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve all ingestion notifications for the current user.
   * @return Returns the ingestion notifications.
   */
  getAllIngestionNotifications(): Observable<IngestionNotificationResponseModelListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/ingestion-notifications";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllIngestionNotifications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllIngestionNotifications(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IngestionNotificationResponseModelListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<IngestionNotificationResponseModelListBaseResultResponseModel>;
        })
      );
  }

  protected processGetAllIngestionNotifications(
    response: HttpResponseBase
  ): Observable<IngestionNotificationResponseModelListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as IngestionNotificationResponseModelListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("No ingestion notifications found for the current user.", status, _responseText, _headers);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Delete a list of ingestion notifications of the current user.
   * @param body (optional) The ids of the notifications to delete (at least one id, each greater than zero).
   * @return If all the notifications were deleted.
   */
  deleteIngestionNotifications(body: DeleteIngestionNotificationsRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/ingestion-notifications";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteIngestionNotifications(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteIngestionNotifications(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDeleteIngestionNotifications(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException(
            "If the id list is null, empty or contains ids that are not greater than zero.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If any of the notifications belongs to another user.", status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException(
            "If any of the notifications or the user identity could not be resolved.",
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Mark a list of ingestion notifications of the current user as read.
   * @param body (optional) The ids of the notifications to mark as read (at least one id, each greater than zero).
   * @return If all the notifications were marked as read.
   */
  markIngestionNotificationsAsRead(body: MarkIngestionNotificationsAsReadRequestModel | undefined): Observable<void> {
    let url_ = this.baseUrl + "/ingestion-notifications/read";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .request("patch", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMarkIngestionNotificationsAsRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMarkIngestionNotificationsAsRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processMarkIngestionNotificationsAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException(
            "If the id list is null, empty or contains ids that are not greater than zero.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If any of the notifications belongs to another user.", status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException(
            "If any of the notifications or the user identity could not be resolved.",
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get interlock status for an object.
   * @param id The ID of the object.
   * @param type (optional) The type of the object interlock.
   * @return Returns interlock information.
   */
  objectInterlocks(id: number, type: ObjectInterlockType | undefined): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/object-interlocks/{id}?";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processObjectInterlocks(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processObjectInterlocks(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processObjectInterlocks(response: HttpResponseBase): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ObjectInterlockResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("If no interlock information is found.", status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create an interlock for an object.
   * @param id The ID of the object.
   * @param type (optional) The type of the object interlock.
   * @return If the interlock is created successfully.
   */
  addObjectInterlock(id: number, type: ObjectInterlockType | undefined): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/object-interlocks/{id}?";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddObjectInterlock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddObjectInterlock(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processAddObjectInterlock(response: HttpResponseBase): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ObjectInterlockResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Remove an interlock from an object.
   * @param id The ID of the object.
   * @param type (optional) The type of the object interlock.
   * @return If the interlock is removed successfully.
   */
  removeObjectInterlock(id: number, type: ObjectInterlockType | undefined): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/object-interlocks/{id}?";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "type=" + encodeURIComponent("" + type) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("delete", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRemoveObjectInterlock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRemoveObjectInterlock(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ObjectInterlockResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processRemoveObjectInterlock(response: HttpResponseBase): Observable<ObjectInterlockResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ObjectInterlockResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Perform a one-line (free-text) search for IBase objects and related entities.
    The query will be interpreted using the provided search strategy and returned as a
    paginated result of matching items (IBase, Facility, Partners etc.).
     * @param searchStrategy (optional)
     * @param type (optional)
     * @param offset (optional)
     * @param elements (optional)
     * @return Search completed successfully and results are returned.
     */
  getIBaseOneLineSearch(
    searchStrategy: SearchStrategy | undefined,
    type: FieldPresetType | undefined,
    query: string,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/one-line-search/ibase?";
    if (searchStrategy === null) throw new globalThis.Error("The parameter 'searchStrategy' cannot be null.");
    else if (searchStrategy !== undefined) url_ += "SearchStrategy=" + encodeURIComponent("" + searchStrategy) + "&";
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "Type=" + encodeURIComponent("" + type) + "&";
    if (query === undefined || query === null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
    else url_ += "Query=" + encodeURIComponent("" + query) + "&";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "Elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIBaseOneLineSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIBaseOneLineSearch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processGetIBaseOneLineSearch(response: HttpResponseBase): Observable<OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("Invalid request parameters.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Perform a one-line (free-text) search restricted to Facilities.
    The query is interpreted using the provided search strategy and returned as a
    paginated list of matching facilities.
     * @param searchStrategy (optional)
     * @param type (optional)
     * @param offset (optional)
     * @param elements (optional)
     * @return Search completed successfully and results are returned.
     */
  getOneLineSearchFacility(
    searchStrategy: SearchStrategy | undefined,
    type: FieldPresetType | undefined,
    query: string,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/one-line-search/facility?";
    if (searchStrategy === null) throw new globalThis.Error("The parameter 'searchStrategy' cannot be null.");
    else if (searchStrategy !== undefined) url_ += "SearchStrategy=" + encodeURIComponent("" + searchStrategy) + "&";
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += "Type=" + encodeURIComponent("" + type) + "&";
    if (query === undefined || query === null) throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
    else url_ += "Query=" + encodeURIComponent("" + query) + "&";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "Elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOneLineSearchFacility(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOneLineSearchFacility(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processGetOneLineSearchFacility(
    response: HttpResponseBase
  ): Observable<OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("Invalid request parameters.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("The search service failed.", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get available roles.
   * @return Returns roles list.
   */
  roles(): Observable<RoleResponseModelListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/roles";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RoleResponseModelListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<RoleResponseModelListBaseResultResponseModel>;
        })
      );
  }

  protected processRoles(response: HttpResponseBase): Observable<RoleResponseModelListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleResponseModelListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no roles are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Searches for Siemens employees by email (GID).
   * @param gid (optional) The email (GID) of the employee to search for.
   * @return Returns the list of found Siemens employees.
   */
  searchByGid(gid: string | undefined): Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/siemens-employees?";
    if (gid === null) throw new globalThis.Error("The parameter 'gid' cannot be null.");
    else if (gid !== undefined) url_ += "gid=" + encodeURIComponent("" + gid) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchByGid(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchByGid(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processSearchByGid(response: HttpResponseBase): Observable<ScdPeopleApiContentResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ScdPeopleApiContentResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the provided GID is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 502) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result502: any = null;
          result502 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Bad Gateway", status, _responseText, _headers, result502);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get current user profile and related data.
   * @return Returns user details.
   */
  profile(): Observable<UserResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users/me/profile";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processProfile(response: HttpResponseBase): Observable<UserResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If user is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Search users with their role information.
   * @param firstName (optional)
   * @param lastName (optional)
   * @param gid (optional)
   * @param department (optional)
   * @param email (optional)
   * @param country (optional)
   * @param isProtected (optional)
   * @param roles (optional)
   * @param offset (optional)
   * @param elements (optional)
   * @return Returns the paginated list of users.
   */
  searchUsers(
    firstName: string | undefined,
    lastName: string | undefined,
    gid: string | undefined,
    department: string | undefined,
    email: string | undefined,
    country: string | undefined,
    isProtected: boolean | undefined,
    roles: RoleType[] | undefined,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<UserManagementResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/users?";
    if (firstName === null) throw new globalThis.Error("The parameter 'firstName' cannot be null.");
    else if (firstName !== undefined) url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
    if (lastName === null) throw new globalThis.Error("The parameter 'lastName' cannot be null.");
    else if (lastName !== undefined) url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
    if (gid === null) throw new globalThis.Error("The parameter 'gid' cannot be null.");
    else if (gid !== undefined) url_ += "Gid=" + encodeURIComponent("" + gid) + "&";
    if (department === null) throw new globalThis.Error("The parameter 'department' cannot be null.");
    else if (department !== undefined) url_ += "Department=" + encodeURIComponent("" + department) + "&";
    if (email === null) throw new globalThis.Error("The parameter 'email' cannot be null.");
    else if (email !== undefined) url_ += "Email=" + encodeURIComponent("" + email) + "&";
    if (country === null) throw new globalThis.Error("The parameter 'country' cannot be null.");
    else if (country !== undefined) url_ += "Country=" + encodeURIComponent("" + country) + "&";
    if (isProtected === null) throw new globalThis.Error("The parameter 'isProtected' cannot be null.");
    else if (isProtected !== undefined) url_ += "IsProtected=" + encodeURIComponent("" + isProtected) + "&";
    if (roles === null) throw new globalThis.Error("The parameter 'roles' cannot be null.");
    else if (roles !== undefined)
      roles &&
        roles.forEach((item) => {
          url_ += "Roles=" + encodeURIComponent("" + item) + "&";
        });
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "Elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processSearchUsers(response: HttpResponseBase): Observable<UserManagementResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Forbidden if the caller lacks the required role.", status, _responseText, _headers, result403);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new user and assign roles.
   * @param body (optional) User information and roles to assign.
   * @return Returns the created user.
   */
  createUserAndRoles(body: UserManagementCreateRequestModel | undefined): Observable<UserManagementResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserAndRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUserAndRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processCreateUserAndRoles(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if validation fails (e.g., required role missing).", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          result409 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if a conflict occurs (e.g., user already exists).", status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          result500 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if an unexpected error occurs.", status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get the current user information (including roles).
   * @return Returns the current user's information.
   */
  getMyUserInfo(): Observable<UserManagementResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users/me";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMyUserInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMyUserInfo(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processGetMyUserInfo(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if the user cannot be identified or no data exists.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get user information by GID, including roles.
   * @param gid The user's GID (identifier).
   * @return Returns the user's information.
   */
  getUserInfoByGid(gid: string): Observable<UserManagementResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users/{gid}";
    if (gid === undefined || gid === null) throw new globalThis.Error("The parameter 'gid' must be defined.");
    url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserInfoByGid(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserInfoByGid(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processGetUserInfoByGid(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("Returned if there is no content.", status, _responseText, _headers);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if the user is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Get a user's role history by GID with pagination.
   * @param gid The user's GID (identifier).
   * @param offset Number of records to skip (offset).
   * @param elements Number of records to return (limit).
   * @return Returns the user's role history.
   */
  getUserRoleHistory(gid: string, offset: number, elements: number): Observable<UserManagementHistoryPagedResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users/{gid}/role-history?";
    if (gid === undefined || gid === null) throw new globalThis.Error("The parameter 'gid' must be defined.");
    url_ = url_.replace("{gid}", encodeURIComponent("" + gid));
    if (offset === undefined || offset === null) throw new globalThis.Error("The parameter 'offset' must be defined and cannot be null.");
    else url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === undefined || elements === null) throw new globalThis.Error("The parameter 'elements' must be defined and cannot be null.");
    else url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserRoleHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserRoleHistory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementHistoryPagedResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementHistoryPagedResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processGetUserRoleHistory(response: HttpResponseBase): Observable<UserManagementHistoryPagedResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementHistoryPagedResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if the history is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update a user's roles.
   * @param body (optional) The changes to apply to the user's roles.
   * @return Returns the user with updated roles.
   */
  updateUserRoles(body: UserManagementUpdateRequestModel | undefined): Observable<UserManagementResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/users/roles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UserManagementResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateUserRoles(response: HttpResponseBase): Observable<UserManagementResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as UserManagementResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Forbidden if the caller lacks the required role.", status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Returned if the user is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Export users and roles as an Excel file.
   * @return Returns the (xlsx) file.
   */
  exportUsers(): Observable<FileResponse> {
    let url_ = this.baseUrl + "/users/export";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExportUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExportUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<FileResponse>;
        })
      );
  }

  protected processExportUsers(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
      let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          result403 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Forbidden if the caller lacks the required role.", status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Returned if the resource is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve all valuelist topic names with display names and the distinct dropdown object types.
   * @return Returns valuelist names and dropdown object types.
   */
  names(): Observable<ValuelistAndDropdownNamesResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/names";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNames(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNames(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ValuelistAndDropdownNamesResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ValuelistAndDropdownNamesResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processNames(response: HttpResponseBase): Observable<ValuelistAndDropdownNamesResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ValuelistAndDropdownNamesResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve a paginated list of dropdown entries for a given object type.
   * @param objectType (optional) The dropdown object type (e.g. "Facility", "IBase", "FIRC").
   * @param offset (optional) Number of items to skip.
   * @param elements (optional) Number of items to take (max 500).
   * @return Returns the paginated list of dropdown entries.
   */
  dropdownEntries(
    objectType: string | undefined,
    offset: number | undefined,
    elements: number | undefined
  ): Observable<DropdownEntryResponseModelBasePaginatedResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/dropdown-entries?";
    if (objectType === null) throw new globalThis.Error("The parameter 'objectType' cannot be null.");
    else if (objectType !== undefined) url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDropdownEntries(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDropdownEntries(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DropdownEntryResponseModelBasePaginatedResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<DropdownEntryResponseModelBasePaginatedResultResponseModel>;
        })
      );
  }

  protected processDropdownEntries(response: HttpResponseBase): Observable<DropdownEntryResponseModelBasePaginatedResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DropdownEntryResponseModelBasePaginatedResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If objectType is empty or elements exceeds 500.", status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates the display name of a topic. Records the modification timestamp and the user who made the change.
   * @param topicName The topic name (e.g. "sibasex.out_vl_companyrole").
   * @param body (optional) Request body containing the new display name.
   * @return Returns the updated topic data.
   */
  displayName(
    topicName: string,
    body: UpdateTopicDisplayNameRequestModel | undefined
  ): Observable<UpdateTopicDisplayNameResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/value-lists/{topicName}/display-name";
    if (topicName === undefined || topicName === null) throw new globalThis.Error("The parameter 'topicName' must be defined.");
    url_ = url_.replace("{topicName}", encodeURIComponent("" + topicName));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("patch", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDisplayName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDisplayName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateTopicDisplayNameResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateTopicDisplayNameResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processDisplayName(response: HttpResponseBase): Observable<UpdateTopicDisplayNameResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateTopicDisplayNameResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the display name is empty.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the topic is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new company role and publish the change to Kafka.
   * @param body (optional) The new company role data.
   * @return Returns the created company role.
   */
  createCompanyRole(body: CreateCompanyRoleRequestModel | undefined): Observable<CompanyRoleResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/company-roles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCompanyRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCompanyRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyRoleResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CompanyRoleResponseModel>;
        })
      );
  }

  protected processCreateCompanyRole(response: HttpResponseBase): Observable<CompanyRoleResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CompanyRoleResponseModel);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            "If Title EN is missing, ContactRole does not exist, or StatusObject is invalid.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing company role by ID and publish the change to Kafka.
   * @param id The ID of the company role to update.
   * @param body (optional) The updated company role data.
   * @return Returns the updated company role.
   */
  updateCompanyRole(id: number, body: UpdateCompanyRoleRequestModel | undefined): Observable<CompanyRoleResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/company-roles/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCompanyRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCompanyRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyRoleResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CompanyRoleResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateCompanyRole(response: HttpResponseBase): Observable<CompanyRoleResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CompanyRoleResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException(
            "If Title EN is missing, ContactRole does not exist, or StatusObject is invalid.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the company role is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new contact role and publish the change to Kafka.
   * @param body (optional) The new contact role data.
   * @return Returns the created contact role.
   */
  createContactRole(body: CreateContactRoleRequestModel | undefined): Observable<ContactRoleResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/contact-roles";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateContactRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateContactRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContactRoleResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ContactRoleResponseModel>;
        })
      );
  }

  protected processCreateContactRole(response: HttpResponseBase): Observable<ContactRoleResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ContactRoleResponseModel);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If Title EN is missing or StatusObject is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing contact role by ID and publish the change to Kafka.
   * @param id The ID of the contact role to update.
   * @param body (optional) The updated contact role data.
   * @return Returns the updated contact role.
   */
  updateContactRole(id: number, body: UpdateContactRoleRequestModel | undefined): Observable<ContactRoleResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/contact-roles/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateContactRole(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateContactRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContactRoleResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ContactRoleResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateContactRole(response: HttpResponseBase): Observable<ContactRoleResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ContactRoleResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If Title EN is missing or StatusObject is invalid.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the contact role is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new country and publish the change to Kafka.
   * @param body (optional) The new country data.
   * @return Returns the created country.
   */
  createCountry(body: CreateCountryRequestModel | undefined): Observable<CountryResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/countries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCountry(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCountry(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryResponseModel>;
        })
      );
  }

  protected processCreateCountry(response: HttpResponseBase): Observable<CountryResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CountryResponseModel);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If Title EN is missing.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing country by ID and publish the change to Kafka.
   * @param id The ID of the country to update.
   * @param body (optional) The updated country data.
   * @return Returns the updated country.
   */
  updateCountry(id: number, body: UpdateCountryRequestModel | undefined): Observable<CountryResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/countries/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCountry(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCountry(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateCountry(response: HttpResponseBase): Observable<CountryResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CountryResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException("If Title EN is missing.", status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the country is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Create a new foreign system and publish the change to Kafka.
   * @param body (optional) The new foreign system data.
   * @return Returns the created foreign system.
   */
  createForeignSystem(body: CreateForeignSystemRequestModel | undefined): Observable<ForeignSystemResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/foreign-systems";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("post", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateForeignSystem(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateForeignSystem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ForeignSystemResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ForeignSystemResponseModel>;
        })
      );
  }

  protected processCreateForeignSystem(response: HttpResponseBase): Observable<ForeignSystemResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ForeignSystemResponseModel);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException(
            "If ForeignSystemId or ForeignSystemName is missing,\nStatusObject is not a valid dropdown alias,\nType is not a valid dropdown alias,\nRemoteAccessDeviceType is not a valid dropdown alias,\nor SystemCountry does not exist in the Country value list.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Update an existing foreign system by ID and publish the change to Kafka.
   * @param id The ID of the foreign system to update.
   * @param body (optional) The updated foreign system data.
   * @return Returns the updated foreign system.
   */
  updateForeignSystem(id: number, body: UpdateForeignSystemRequestModel | undefined): Observable<ForeignSystemResponseModelBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-list-management/foreign-systems/{id}";
    if (id === undefined || id === null) throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    };

    return this.http
      .request("put", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateForeignSystem(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateForeignSystem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ForeignSystemResponseModelBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ForeignSystemResponseModelBaseResultResponseModel>;
        })
      );
  }

  protected processUpdateForeignSystem(response: HttpResponseBase): Observable<ForeignSystemResponseModelBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ForeignSystemResponseModelBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails);
          return throwException(
            "If ForeignSystemName is missing,\nStatusObject is not a valid dropdown alias,\nType is not a valid dropdown alias,\nRemoteAccessDeviceType is not a valid dropdown alias,\nor SystemCountry does not exist in the Country value list.",
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          result401 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("If the user identity could not be resolved.", status, _responseText, _headers, result401);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the foreign system is not found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve company roles.
   * @param language EN (only english available for now)
   * @return Returns a list of company roles.
   */
  companyRoles(language: string): Observable<CompanyRoleResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/company-roles?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCompanyRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCompanyRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyRoleResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CompanyRoleResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processCompanyRoles(response: HttpResponseBase): Observable<CompanyRoleResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CompanyRoleResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve contact roles.
   * @param language EN (only english available for now)
   * @return Returns a list of contact roles.
   */
  contactRoles(language: string): Observable<ContactRoleResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/contact-roles?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContactRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContactRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContactRoleResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ContactRoleResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processContactRoles(response: HttpResponseBase): Observable<ContactRoleResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ContactRoleResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the list of countries.
   * @param language EN (only english available for now)
   * @return Returns the list of countries.
   */
  countries(language: string): Observable<CountryResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/countries?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountries(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountries(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processCountries(response: HttpResponseBase): Observable<CountryResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as CountryResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no countries are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the depth structures.
   * @param language EN (only english available for now)
   * @return Returns the list of depth structures.
   */
  depthStructures(language: string): Observable<DepthStructureResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/depth-structures?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDepthStructures(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDepthStructures(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DepthStructureResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<DepthStructureResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processDepthStructures(response: HttpResponseBase): Observable<DepthStructureResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DepthStructureResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the foreign systems.
   * @param language EN (only english available for now)
   * @return Returns the list of foreign systems.
   */
  foreignSystems(language: string): Observable<ForeignSystemResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/foreign-systems?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processForeignSystems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processForeignSystems(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ForeignSystemResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ForeignSystemResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processForeignSystems(response: HttpResponseBase): Observable<ForeignSystemResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ForeignSystemResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the group classification keys.
   * @param language EN (only english available for now)
   * @return Returns the list of group classification keys.
   */
  groupClassificationKeys(language: string): Observable<GroupClassificationKeyResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/group-classification-keys?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGroupClassificationKeys(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGroupClassificationKeys(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GroupClassificationKeyResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<GroupClassificationKeyResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processGroupClassificationKeys(response: HttpResponseBase): Observable<GroupClassificationKeyResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GroupClassificationKeyResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the main purpose groups.
   * @param language EN (only english available for now)
   * @return Returns the list of main purpose groups.
   */
  purposeGroups(language: string): Observable<MainPurposeGroupResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/purpose-groups?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPurposeGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPurposeGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MainPurposeGroupResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<MainPurposeGroupResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processPurposeGroups(response: HttpResponseBase): Observable<MainPurposeGroupResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as MainPurposeGroupResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve the maintenance limitation groups.
   * @param language (optional) EN (only english available for now)
   * @return Returns the list of maintenance limitation groups.
   */
  maintenanceGroups(language: string | undefined): Observable<MaintenanceGroupResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/maintenance-groups?";
    if (language === null) throw new globalThis.Error("The parameter 'language' cannot be null.");
    else if (language !== undefined) url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMaintenanceGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMaintenanceGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MaintenanceGroupResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<MaintenanceGroupResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processMaintenanceGroups(response: HttpResponseBase): Observable<MaintenanceGroupResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as MaintenanceGroupResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve plant IDs.
   * @return Returns the list of plant IDs.
   */
  plantIds(): Observable<PlantIdResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/plant-ids";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPlantIds(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPlantIds(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PlantIdResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<PlantIdResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processPlantIds(response: HttpResponseBase): Observable<PlantIdResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PlantIdResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve product hierarchy as product family.
   * @param offset (optional) Number of items to skip.
   * @param elements (optional) Number of items to take.
   * @param language EN (only english available for now)
   * @return Returns the list of product hierarchies as product family.
   */
  productFamilies(
    offset: number | undefined,
    elements: number | undefined,
    language: string
  ): Observable<ProductHierarchyResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/product-families?";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProductFamilies(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProductFamilies(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProductHierarchyResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ProductHierarchyResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processProductFamilies(response: HttpResponseBase): Observable<ProductHierarchyResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProductHierarchyResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If the elements parameter is greater than 500.", status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve SISICs.
   * @param language EN (only english available for now)
   * @return Returns the list of SISICs.
   */
  sisics(language: string): Observable<SisicResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/sisics?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSisics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSisics(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SisicResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SisicResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processSisics(response: HttpResponseBase): Observable<SisicResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as SisicResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve sub-national units by country.
   * @param country (optional) The country code.
   * @return Returns the list of sub-national units.
   */
  subNationalUnits(country: string | undefined): Observable<SubNationalUnitResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/sub-national-units?";
    if (country === null) throw new globalThis.Error("The parameter 'country' cannot be null.");
    else if (country !== undefined) url_ += "country=" + encodeURIComponent("" + country) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubNationalUnits(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubNationalUnits(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SubNationalUnitResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<SubNationalUnitResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processSubNationalUnits(response: HttpResponseBase): Observable<SubNationalUnitResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SubNationalUnitResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve operational territory structures, optionally filtered by country.
   * @param language EN (only english available for now)
   * @param country (optional) The country code (optional).
   * @return Returns the list of operational territory structures. Each item's label is "country - territoryStructureOperational - title".
   */
  territoryStructuresOperational(
    language: string,
    country: string | undefined
  ): Observable<TerritoryStructureOperationalResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/territory-structures-operational?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    if (country === null) throw new globalThis.Error("The parameter 'country' cannot be null.");
    else if (country !== undefined) url_ += "country=" + encodeURIComponent("" + country) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTerritoryStructuresOperational(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTerritoryStructuresOperational(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TerritoryStructureOperationalResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<TerritoryStructureOperationalResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processTerritoryStructuresOperational(
    response: HttpResponseBase
  ): Observable<TerritoryStructureOperationalResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as TerritoryStructureOperationalResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve timezone metadata by subnational unit.
   * @param language EN (only english available for now)
   * @param subNationalUnit (optional) The subnational unit code.
   * @return Returns the list of timezone metadata.
   */
  timezones(language: string, subNationalUnit: string | undefined): Observable<TimezoneMetadataResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/timezones?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    if (subNationalUnit === null) throw new globalThis.Error("The parameter 'subNationalUnit' cannot be null.");
    else if (subNationalUnit !== undefined) url_ += "subNationalUnit=" + encodeURIComponent("" + subNationalUnit) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTimezones(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTimezones(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TimezoneMetadataResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<TimezoneMetadataResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processTimezones(response: HttpResponseBase): Observable<TimezoneMetadataResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as TimezoneMetadataResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve verticals.
   * @param language EN (only english available for now)
   * @return Returns the list of verticals.
   */
  verticals(language: string): Observable<VerticalResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/verticals?";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processVerticals(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processVerticals(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<VerticalResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<VerticalResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processVerticals(response: HttpResponseBase): Observable<VerticalResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as VerticalResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("If no verticals are found.", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve product hierarchy as product group.
   * @param offset (optional) Number of items to skip.
   * @param elements (optional) Number of items to take.
   * @param language EN (only english available for now)
   * @return Returns the list of product hierarchies as product group.
   */
  productGroups(
    offset: number | undefined,
    elements: number | undefined,
    language: string
  ): Observable<ProductHierarchyResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/product-groups?";
    if (offset === null) throw new globalThis.Error("The parameter 'offset' cannot be null.");
    else if (offset !== undefined) url_ += "offset=" + encodeURIComponent("" + offset) + "&";
    if (elements === null) throw new globalThis.Error("The parameter 'elements' cannot be null.");
    else if (elements !== undefined) url_ += "elements=" + encodeURIComponent("" + elements) + "&";
    if (language === undefined || language === null) throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
    else url_ += "language=" + encodeURIComponent("" + language) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProductGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProductGroups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProductHierarchyResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ProductHierarchyResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processProductGroups(response: HttpResponseBase): Observable<ProductHierarchyResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ""
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ProductHierarchyResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          result400 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
          return throwException("Bad Request", status, _responseText, _headers, result400);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Retrieve pck.
   * @return Returns the list of pck.
   */
  pck(): Observable<PckResponseModelIListBaseResultResponseModel> {
    let url_ = this.baseUrl + "/value-lists/pck";
    url_ = url_.replace(/[?&]$/, "");

    let options_: any = {
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        Accept: "application/json",
      }),
    };

    return this.http
      .request("get", url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPck(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPck(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PckResponseModelIListBaseResultResponseModel>;
            }
          } else return _observableThrow(response_) as any as Observable<PckResponseModelIListBaseResultResponseModel>;
        })
      );
  }

  protected processPck(response: HttpResponseBase): Observable<PckResponseModelIListBaseResultResponseModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PckResponseModelIListBaseResultResponseModel);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          result404 = _responseText === "" ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ErrorExceptionResponseModel);
          return throwException("Not Found", status, _responseText, _headers, result404);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface AddressInformationRequestModel {
  country: string | null;
  subNationalUnit: string | null;
  cityInt: string | null;
  cityNat: string | null;
  streetInt: string | null;
  streetNat: string | null;
  postalCode: string | null;
  postOfficeBox: string | null;
  postalCodePostOfficeBox: string | null;
  timeZone: string | null;
}

export interface AddressInformationResponseModel {
  country: string | null;
  subNationalUnit: string | null;
  cityInt: string | null;
  cityNat: string | null;
  streetInt: string | null;
  streetNat: string | null;
  postalCode: string | null;
  postOfficeBox: string | null;
  postalCodePostOfficeBox: string | null;
  timeZone: string | null;
}

export interface ApplicationVersionRequestModel {
  major: number;
  minor: number;
  patch: number;
}

export interface ApplicationVersionResponseModel {
  major: number;
  minor: number;
  patch: number;
}

export interface ApplicationVersionResponseModelBaseResultResponseModel {
  data: ApplicationVersionResponseModel;
  links: LinksResponseModel;
}

export interface AttachmentValueModel {
  attachmentTypes: { [key: string]: string } | null;
  informationClasses: { [key: string]: string } | null;
  statusObjects: { [key: string]: string } | null;
  qualityIndicators: { [key: string]: string } | null;
}

export interface CompanyRoleResponseModel {
  id: number;
  role: string | null;
  contactRole: string | null;
  customerRole: boolean;
  defaultIbaseRole: boolean;
  title: string | null;
  validForStandardCompanyRole: boolean;
  statusObject: string | null;
  lastChangeTimestamp: Date;
  language: string | null;
}

export interface CompanyRoleResponseModelBaseResultResponseModel {
  data: CompanyRoleResponseModel;
  links: LinksResponseModel;
}

export interface CompanyRoleResponseModelIListBaseResultResponseModel {
  data: CompanyRoleResponseModel[] | null;
  links: LinksResponseModel;
}

export interface ComplexSearchIBaseRequestModel {
  offset: number | null;
  elements: number | null;
  orderBy: string | null;
  sortOrder: SearchSettingsSortOrderEnumRequestModel;
  searchIncludes: SearchIncludesRequestModel;
  complexSearchParameterServiceModel: ComplexSearchParameterRequestModel[] | null;
}

export interface ComplexSearchIBaseResponseModel {
  offset: number | null;
  elements: number | null;
  matchedCount: number;
  results: SearchIBaseResponseModel[] | null;
}

export interface ComplexSearchIBaseResponseModelBaseResultResponseModel {
  data: ComplexSearchIBaseResponseModel;
  links: LinksResponseModel;
}

export enum ComplexSearchOperatorEnumRequestModel {
  Exact = "Exact",
  FullText = "FullText",
  GreaterThan = "GreaterThan",
  GreaterThanOrEqual = "GreaterThanOrEqual",
  LessThan = "LessThan",
  LessThanOrEqual = "LessThanOrEqual",
  Equal = "Equal",
  Between = "Between",
  Or = "Or",
}

export interface ComplexSearchParameterRequestModel {
  path: string | null;
  operatorEnum: ComplexSearchOperatorEnumRequestModel;
  values: number[] | null;
}

export interface ContactInformationRequestModel {
  email: string | null;
  fax: string | null;
  homePage: string | null;
  phone: string | null;
}

export interface ContactInformationResponseModel {
  email: string | null;
  fax: string | null;
  homePage: string | null;
  phone: string | null;
}

export interface ContactPersonForeignSystemValueModel {
  statusObjects: { [key: string]: string } | null;
}

export interface ContactPersonValueModel {
  salutations: { [key: string]: string } | null;
  qualityIndicators: { [key: string]: string } | null;
  uniqueEmails: { [key: string]: string } | null;
  statusObjects: { [key: string]: string } | null;
}

export interface ContactRoleConnectorValueModel {
  qualityIndicators: { [key: string]: string } | null;
  refObjects: { [key: string]: string } | null;
  statusObjects: { [key: string]: string } | null;
}

export interface ContactRoleResponseModel {
  id: number;
  role: string | null;
  companyRole: string[] | null;
  statusObject: string | null;
  title: string | null;
  creationTimestamp: Date;
  lastChangeTimestamp: Date;
}

export interface ContactRoleResponseModelBaseResultResponseModel {
  data: ContactRoleResponseModel;
  links: LinksResponseModel;
}

export interface ContactRoleResponseModelIListBaseResultResponseModel {
  data: ContactRoleResponseModel[] | null;
  links: LinksResponseModel;
}

export interface ContactRoleValueModel {
  statusObjects: { [key: string]: string } | null;
}

export interface CountryResponseModel {
  id: number;
  countryCode: string | null;
  lastChangedTs: Date;
  currency: string | null;
  continent: string | null;
  countryCharacteristic: string | null;
  language: string | null;
  leadCountry: string | null;
  summerTimeStart: string | null;
  summerTimeEnd: string | null;
  timeZoneTitle: string | null;
  additionalOffset: number;
  comments: string | null;
  codeInternational: string | null;
  criticalForEcc: boolean;
  noAutomatedSetOfAwvCode: boolean;
  poRequestNotAllowed: boolean;
  streetZipCodeRule: string | null;
  subNationalUnitsAvailable: boolean | null;
  territoryStructureOperationalAvailable: boolean;
  valuableCompanyThreshold: number;
  minZipCode: string | null;
  insertPosition: string | null;
  insertionString: string | null;
  numberOfFactTitleFields: string | null;
  title: string | null;
  zipCodeRuleDescription: string | null;
  errorMessage: string | null;
  remarks: string | null;
  warning1: string | null;
  warning2: string | null;
  countryGroup: number | null;
  patacAuditCycle: number | null;
  patacChangeDate: Date | null;
  patacEmailAddress: string | null;
  patacDescription: string | null;
  patacId: string | null;
  patacSetBy: string | null;
  patacTestResult: string | null;
  patacValidFrom: Date | null;
  patacValidTo: Date | null;
  readonly label: string | null;
}

export interface CountryResponseModelBaseResultResponseModel {
  data: CountryResponseModel;
  links: LinksResponseModel;
}

export interface CountryResponseModelIListBaseResultResponseModel {
  data: CountryResponseModel[] | null;
  links: LinksResponseModel;
}

export interface CountryValueModel {
  countryCharacteristic: { [key: string]: string } | null;
  countryGroup: { [key: string]: string } | null;
  summertimeStart: { [key: string]: string } | null;
  summertimeEnd: { [key: string]: string } | null;
  patacTestResult: { [key: string]: string } | null;
}

export interface CreateCompanyRoleRequestModel {
  role: string;
  contactRole: string | null;
  customerRole: boolean;
  defaultIbaseRole: boolean;
  title: { [key: string]: string };
  validForStandardCompanyRole: boolean;
  statusObject: string;
}

export interface CreateContactRoleRequestModel {
  role: string;
  companyRole: string[] | null;
  title: { [key: string]: string };
  statusObject: string;
}

export interface CreateCountryRequestModel {
  countryCode: string;
  title: { [key: string]: string };
  status: string | null;
  currency: string | null;
  continent: string | null;
  countryCharacteristic: string | null;
  language: string | null;
  leadCountry: string | null;
  summerTimeStart: string | null;
  summerTimeEnd: string | null;
  timeZoneTitle: string | null;
  additionalOffset: number;
  comments: string | null;
  codeInternational: string | null;
  criticalForEcc: boolean;
  noAutomatedSetOfAwvCode: boolean;
  poRequestNotAllowed: boolean;
  streetZipCodeRule: string | null;
  subNationalUnitsAvailable: boolean | null;
  territoryStructureOperationalAvailable: boolean;
  valuableCompanyThreshold: number;
  minZipCode: string | null;
  insertPosition: string | null;
  insertionString: string | null;
  numberOfFactTitleFields: string | null;
  zipCodeRuleDescription: { [key: string]: string } | null;
  errorMessage: { [key: string]: string } | null;
  remarks: { [key: string]: string } | null;
  warning1: { [key: string]: string } | null;
  warning2: { [key: string]: string } | null;
  countryGroup: number | null;
  patacAuditCycle: number | null;
  patacChangeDate: Date | null;
  patacEmailAddress: string | null;
  patacDescription: string | null;
  patacId: string | null;
  patacSetBy: string | null;
  patacTestResult: string | null;
  patacValidFrom: Date | null;
  patacValidTo: Date | null;
}

export interface CreateErrorFilterRequestModel {
  name: string | null;
  value: string | null;
}

export interface CreateFacilityRequestModel {
  type: FacilityType;
  facilityDetails: FacilityDetailsRequestModel;
}

export interface CreateForeignSystemRequestModel {
  foreignSystemId: string;
  foreignSystemName: string;
  statusObject: string;
  type: string;
  remoteAccessDeviceType: string | null;
  systemCountry: string | null;
  systemUrl: string | null;
  title: string | null;
  mandt: string | null;
  sysId: string | null;
  isAssetConnectorSystem: boolean;
  isCheckAgainstHana: boolean;
  isDeliverEdDataSystem: boolean;
  isErp: boolean;
  isFsErp: boolean;
  isLsaMandatoryForErp: boolean;
  isRelevantForIBase: boolean;
  isRelevantForPerson: boolean;
  isRemoteAccessSystem: boolean;
  isUniqueInIBase: boolean;
  isUpdateFlag: boolean;
  isUserRelevant: boolean;
  isForeignIdUnique: boolean | null;
}

export interface CreateIBaseRequestModel {
  name: string | null;
  classification: IBaseClassification;
  details: IBaseDetailsRequestModel;
  msgId: string | null;
}

export interface DeleteIngestionNotificationsRequestModel {
  notificationIds: number[];
}

export interface DeleteResponseModel {
  success: boolean;
  message: string | null;
}

export interface DeleteResponseModelBaseResultResponseModel {
  data: DeleteResponseModel;
  links: LinksResponseModel;
}

export interface DepthStructureResponseModel {
  nkDepthstructure: string | null;
  readonly label: string | null;
}

export interface DepthStructureResponseModelIListBaseResultResponseModel {
  data: DepthStructureResponseModel[] | null;
  links: LinksResponseModel;
}

export interface DropdownEntryResponseModel {
  id: number;
  active: boolean;
  alias: string | null;
  identifier: string | null;
  translations: { [key: string]: string } | null;
  property: string | null;
  lastChangeTimestamp: Date | null;
}

export interface DropdownEntryResponseModelBasePaginatedResultResponseModel {
  data: DropdownEntryResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface DropdownValuesResponseModel {
  iBaseForeignSystems: IBaseForeignSystemValueModel;
  attachments: AttachmentValueModel;
  iBases: IBaseValueModel;
  facilities: FacilityValueModel;
  facilityForeignSystems: FacilityForeignSystemValueModel;
  fircs: FircValueModel;
  country: CountryValueModel;
  foreignSystems: ForeignSystemValueModel;
  contactPersons: ContactPersonValueModel;
  contactPersonForeignSystems: ContactPersonForeignSystemValueModel;
  contactRoles: ContactRoleValueModel;
  contactRoleConnectors: ContactRoleConnectorValueModel;
}

export interface DropdownValuesResponseModelBaseResultResponseModel {
  data: DropdownValuesResponseModel;
  links: LinksResponseModel;
}

export interface ErrorCorrectionDetailedResponseModel {
  errorId: string | null;
  type: ErrorTypeId[] | null;
  isResolved: boolean | null;
  ingestId: string | null;
  timestamp: Date | null;
  location: string | null;
  eventId: string | null;
  errors: ErrorItemResponseModel[] | null;
  refIDsError: number[] | null;
  objectGib: any | null;
  objectId: number | null;
  objectType: ErrorObjectTypeId;
  dataSource: string | null;
  isDeprecated: boolean | null;
  errorObjectProducer: ErrorDtoErrorObjectProducer;
  maintenanceGroup: string | null;
}

export interface ErrorCorrectionDetailedResponseModelBaseResultResponseModel {
  data: ErrorCorrectionDetailedResponseModel;
  links: LinksResponseModel;
}

export interface ErrorCorrectionResponseModel {
  errorId: string | null;
  type: ErrorTypeId[] | null;
  objectType: ErrorObjectTypeId;
  objectId: number | null;
  errorDescription: string | null;
  dataSource: string | null;
  ingestId: string | null;
  timestamp: Date | null;
}

export interface ErrorCorrectionResponseModelBasePaginatedResultResponseModel {
  data: ErrorCorrectionResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export enum ErrorDtoErrorObjectProducer {
  Unknown = "Unknown",
  IL = "IL",
  SDC = "SDC",
}

export interface ErrorExceptionResponseModel {
  statusCode: number;
  code: string | null;
  message: string | null;
  details: string | null;
}

export interface ErrorFilterReponseModel {
  id: number;
  name: string | null;
  value: string | null;
}

export interface ErrorFilterReponseModelBaseResultResponseModel {
  data: ErrorFilterReponseModel;
  links: LinksResponseModel;
}

export interface ErrorFilterReponseModelIListBaseResultResponseModel {
  data: ErrorFilterReponseModel[] | null;
  links: LinksResponseModel;
}

export interface ErrorItemResponseModel {
  errorCode: string | null;
  errorDescription: string | null;
}

export enum ErrorObjectProducerId {
  IL = "IL",
  SDC = "SDC",
}

export enum ErrorObjectTypeId {
  IBase = "IBase",
  Attachment = "Attachment",
  ContactPerson = "ContactPerson",
  ContactRoleConnector = "ContactRoleConnector",
  Facility = "Facility",
  FacilityIBaseRoleConnector = "FacilityIBaseRoleConnector",
  FacilitySiteConnector = "FacilitySiteConnector",
}

export enum ErrorTypeId {
  DataError = "DataError",
  ReferenceError = "ReferenceError",
}

export interface FacilityConnectedAssetsResponseModel {
  id: number | null;
  status: string | null;
  classification: string | null;
  lifecycleStatus: string | null;
  customerRole: string | null;
  identifier: string | null;
}

export interface FacilityDetailsRequestModel {
  generalInformation: FacilityGeneralInformationRequestModel;
  addressInformation: AddressInformationRequestModel;
  operationalFacilityInformation: OperationalFacilityInformationRequestModel;
  siteInformation: SiteInformationRequestModel;
  contactInformation: ContactInformationRequestModel;
  gpsInformation: GpsInformationRequestModel;
  furtherInformation: FurtherInformationRequestModel;
  foreignSystems: FacilityForeignSystemsRequestModel[] | null;
  hierarchyInformation: FacilityHierarchyInformationRequestModel;
  history: FacilityHistoryRequestModel;
}

export interface FacilityDetailsResponseModel {
  generalInformation: FacilityGeneralInformationResponseModel;
  addressInformation: AddressInformationResponseModel;
  operationalFacilityInformation: OperationalFacilityInformationResponseModel;
  siteInformation: SiteInformationResponseModel;
  contactInformation: ContactInformationResponseModel;
  furtherInformation: FurtherInformationResponseModel;
  gpsInformation: GpsInformationResponseModel;
  hierarchyInformations: FacilityHierarchyInformationResponseModel;
  foreignSystems: FacilityForeignSystemsResponseModel[] | null;
  connectedAssets: FacilityConnectedAssetsResponseModel[] | null;
  history: FacilityHistoryResponseModel;
}

export interface FacilityFilterRequestModel {
  id: number;
  name: string | null;
  value: string | null;
}

export interface FacilityFilterResponseModel {
  id: number;
  name: string | null;
  value: string | null;
}

export interface FacilityFilterResponseModelBaseResultResponseModel {
  data: FacilityFilterResponseModel;
  links: LinksResponseModel;
}

export interface FacilityFilterResponseModelIEnumerableBaseResultResponseModel {
  data: FacilityFilterResponseModel[] | null;
  links: LinksResponseModel;
}

export interface FacilityForeignSystemValueModel {
  statusObjects: { [key: string]: string } | null;
  foreignSystemTypes: { [key: string]: string } | null;
}

export interface FacilityForeignSystemsRequestModel {
  title: string | null;
  type: string | null;
  number: string | null;
  status: string | null;
}

export interface FacilityForeignSystemsResponseModel {
  title: string | null;
  type: string | null;
  number: string | null;
  status: string | null;
}

export interface FacilityGeneralInformationRequestModel {
  dataQuality: string | null;
  addressType: string | null;
  status: string | null;
  accountType: string | null;
  siemensInternal: boolean | null;
  typeOfSite: string | null;
}

export interface FacilityGeneralInformationResponseModel {
  dataQuality: string | null;
  addressType: string | null;
  accountType: string | null;
  siemensInternal: boolean | null;
  typeOfSite: string | null;
  status: string | null;
}

export interface FacilityHierarchyInformationChildRequestModel {
  id: number | null;
  status: string | null;
  type: string | null;
  accountType: string | null;
  facilityName: string | null;
  zipCode: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
}

export interface FacilityHierarchyInformationChildResponseModel {
  id: number | null;
  status: string | null;
  type: string | null;
  accountType: string | null;
  facilityName: string | null;
  zipCode: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
}

export interface FacilityHierarchyInformationParentRequestModel {
  id: number | null;
  status: string | null;
  type: string | null;
  accountType: string | null;
  facilityName: string | null;
  zipCode: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
  ifa: string | null;
  duns: string | null;
  orgId: string | null;
}

export interface FacilityHierarchyInformationParentResponseModel {
  id: number | null;
  status: string | null;
  type: string | null;
  accountType: string | null;
  facilityName: string | null;
  zipCode: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
  ifa: string | null;
  duns: string | null;
  orgId: string | null;
}

export interface FacilityHierarchyInformationRequestModel {
  childs: FacilityHierarchyInformationChildRequestModel[] | null;
  parent: FacilityHierarchyInformationParentRequestModel;
}

export interface FacilityHierarchyInformationResponseModel {
  childs: FacilityHierarchyInformationChildResponseModel[] | null;
  parent: FacilityHierarchyInformationParentResponseModel;
}

export interface FacilityHierarchyResponseModel {
  id: number | null;
  country: string | null;
  siteName: string | null;
  street: string | null;
  zipCode: string | null;
  city: string | null;
  type: string | null;
  subType: string | null;
  accountType: string | null;
  ancestors: FacilityHierarchyResponseModel[] | null;
  descendants: FacilityHierarchyResponseModel[] | null;
  refIdParentFacility: number | null;
  refIdParentDUNS: number | null;
}

export interface FacilityHierarchyResponseModelBaseResultResponseModel {
  data: FacilityHierarchyResponseModel;
  links: LinksResponseModel;
}

export interface FacilityHistoryRequestModel {
  createdAt: Date | null;
  lastChangeAt: Date | null;
}

export interface FacilityHistoryResponseModel {
  createdAt: Date | null;
  lastChangeAt: Date | null;
}

export interface FacilityResponseModel {
  id: number | null;
  type: string | null;
  isCached: boolean;
  facilityDetails: FacilityDetailsResponseModel;
}

export interface FacilityResponseModelBaseResultResponseModel {
  data: FacilityResponseModel;
  links: LinksResponseModel;
}

export interface FacilitySearchResponseModel {
  id: number | null;
  lastChangeTimestamp: Date | null;
  country: string | null;
  siteNameInt: string | null;
  streetInt: string | null;
  zipCode: string | null;
  cityInt: string | null;
  status: string | null;
  type: string | null;
  accountType: string | null;
}

export interface FacilitySearchResponseModelBasePaginatedResultResponseModel {
  data: FacilitySearchResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export enum FacilityType {
  OperationalFacility = "OperationalFacility",
  SubSite = "SubSite",
  StandAloneSite = "StandAloneSite",
}

export interface FacilityValueModel {
  statusObjects: { [key: string]: string } | null;
  accountTypes: { [key: string]: string } | null;
  types: { [key: string]: string } | null;
  salesPotentialCategories: { [key: string]: string } | null;
  governmentalBusinesses: { [key: string]: string } | null;
  qualityIndicators: { [key: string]: string } | null;
  typeOfSites: { [key: string]: string } | null;
  addressTypes: { [key: string]: string } | null;
}

export enum FieldPresetType {
  Balanced = "Balanced",
  IBaseIdentifier = "IBaseIdentifier",
  IBaseRelations = "IBaseRelations",
  IBase = "IBase",
  FacilityIdentifier = "FacilityIdentifier",
  FacilityRelations = "FacilityRelations",
  Facility = "Facility",
  ContactPerson = "ContactPerson",
  Global = "Global",
  Service = "Service",
}

export interface FircValueModel {
  statusObjects: { [key: string]: string } | null;
  qualityIndicators: { [key: string]: string } | null;
}

export interface ForeignSystemResponseModel {
  lastChangeTimestamp: Date;
  foreignSystemId: string | null;
  systemCountry: string | null;
  type: string | null;
  remoteAccessDeviceType: string | null;
  isAssetConnectorSystem: boolean;
  isCheckAgainstHana: boolean;
  isDeliverEdDataSystem: boolean;
  isErp: boolean;
  isFsErp: boolean;
  isLsaMandatoryForErp: boolean;
  mandt: string | null;
  isRelevantForIBase: boolean;
  isRelevantForPerson: boolean;
  isRemoteAccessSystem: boolean;
  sysId: string | null;
  foreignSystemName: string | null;
  systemUrl: string | null;
  title: string | null;
  isUniqueInIBase: boolean;
  isUpdateFlag: boolean;
  isUserRelevant: boolean;
  isForeignIdUnique: boolean | null;
}

export interface ForeignSystemResponseModelBaseResultResponseModel {
  data: ForeignSystemResponseModel;
  links: LinksResponseModel;
}

export interface ForeignSystemResponseModelIListBaseResultResponseModel {
  data: ForeignSystemResponseModel[] | null;
  links: LinksResponseModel;
}

export interface ForeignSystemValueModel {
  statusObjects: { [key: string]: string } | null;
  types: { [key: string]: string } | null;
  remoteAccessDeviceTypes: { [key: string]: string } | null;
}

export interface FurtherInformationRequestModel {
  territoryStructureOperational: string | null;
  territoryStructureSales: string | null;
  blockedByCreditManagement: boolean | null;
  blockedForBilling: boolean | null;
  blockedForDelivery: boolean | null;
  blockedForOrder: boolean | null;
  blockedForPurchasing: boolean | null;
  blockedForSalesSupport: boolean | null;
}

export interface FurtherInformationResponseModel {
  territoryStructureOperational: string | null;
  territoryStructureSales: string | null;
  blockedByCreditManagement: boolean | null;
  blockedForBilling: boolean | null;
  blockedForDelivery: boolean | null;
  blockedForOrder: boolean | null;
  blockedForPurchasing: boolean | null;
  blockedForSalesSupport: boolean | null;
}

export interface GibOptionResponseModel {
  optionId: string | null;
  text: string | null;
}

export interface GibOptionsRequestModel {
  optionId: string | null;
  text: string | null;
}

export interface GpsInformationRequestModel {
  latitude: string | null;
  longitude: string | null;
  altitude: string | null;
  gpsQuality: string | null;
  geolocationDescription: string | null;
}

export interface GpsInformationResponseModel {
  latitude: string | null;
  longitude: string | null;
  altitude: string | null;
  gpsQuality: string | null;
  geolocationDescription: string | null;
}

export interface GroupClassificationKeyResponseModel {
  id: number;
  nkGroupClassificationKey: string | null;
  groupClassificationKeyName: string | null;
  depthStructure: string | null;
}

export interface GroupClassificationKeyResponseModelIListBaseResultResponseModel {
  data: GroupClassificationKeyResponseModel[] | null;
  links: LinksResponseModel;
}

export interface IBaseAttachmentRequestModel {
  id: number | null;
  comment: string | null;
  creationTimestamp: Date | null;
  description: string | null;
  fileExtension: string | null;
  filesize: string | null;
  lastChangeTimestamp: Date | null;
  link: string | null;
  createdBy: string | null;
  lastChangedBy: string | null;
  name: string | null;
  attachmentType: string | null;
}

export interface IBaseAttachmentResponseModel {
  id: number | null;
  comment: string | null;
  creationTimestamp: Date | null;
  description: string | null;
  fileExtension: string | null;
  filesize: string | null;
  lastChangeTimestamp: Date | null;
  link: string | null;
  createdBy: string | null;
  lastChangedBy: string | null;
  name: string | null;
  attachmentType: string | null;
}

export interface IBaseAttributesRequestModel {
  attributeName: string | null;
  unit: string | null;
  value: string | null;
  attributeType: string | null;
  status: string | null;
}

export interface IBaseAttributesResponseModel {
  attributeName: string | null;
  unit: string | null;
  value: string | null;
  attributeType: string | null;
  status: string | null;
}

export enum IBaseClassification {
  CommercialAsset = "CommercialAsset",
  SpatialAsset = "SpatialAsset",
  TechnicalAsset = "TechnicalAsset",
  Component = "Component",
  SubComponent = "SubComponent",
}

export interface IBaseContactPersonsRequestModel {
  firstNameInt: string | null;
  lastNameInt: string | null;
  email: string | null;
  phone: string | null;
  siemensInternal: boolean | null;
  roleDescription: string | null;
  contactRole: string | null;
  status: string | null;
}

export interface IBaseContactPersonsResponseModel {
  gid: string | null;
  firstNameInt: string | null;
  lastNameInt: string | null;
  email: string | null;
  phone: string | null;
  siemensInternal: boolean | null;
  roleDescription: string | null;
  contactRole: string | null;
  status: string | null;
  department: string | null;
}

export interface IBaseDateInformationRequestModel {
  productionDate: Date | null;
  firstDeliveryDate: Date | null;
  endOfFirstCommissioning: Date | null;
  endOfCommissioning: Date | null;
  startOfOperation: Date | null;
  endOfInternalWarranty: Date | null;
  endOfExternalWarranty: Date | null;
  startOfExternalWarranty: Date | null;
}

export interface IBaseDateInformationResponseModel {
  productionDate: Date | null;
  firstDeliveryDate: Date | null;
  endOfFirstCommissioning: Date | null;
  endOfCommissioning: Date | null;
  startOfOperation: Date | null;
  endOfInternalWarranty: Date | null;
  endOfExternalWarranty: Date | null;
  startOfExternalWarranty: Date | null;
}

export interface IBaseDetailsRequestModel {
  generalInformation: IBaseGeneralInformationRequestModel;
  identifierAndOrganizationalInformation: IBaseIdentifierAndOrganizationalInformationRequestModel;
  dateInformation: IBaseDateInformationRequestModel;
  manufacturingInformation: IBaseManufacturingInformationRequestModel;
  installedInformation: IBaseInstalledInformationRequestModel;
  furtherInformation: IBaseFurtherInformationRequestModel;
  gpsInformation: IBaseGpsInformationRequestModel;
  partnerInformation: IBasePartnerInformationRequestModel[] | null;
  hierarchyInformation: IBaseHierarchyInformationRequestModel;
  furtherRelations: IBaseFurtherRelationRequestModel[] | null;
  attributes: IBaseAttributesRequestModel[] | null;
  foreignSystems: IBaseForeignSystemsRequestModel[] | null;
  contactPerson: IBaseContactPersonsRequestModel[] | null;
  attachments: IBaseAttachmentRequestModel[] | null;
  history: IBaseHistoryRequestModel;
}

export interface IBaseDetailsResponseModel {
  generalInformation: IBaseGeneralInformationResponseModel;
  identifierAndOrganizationalInformation: IBaseIdentifierAndOrganizationalInformationResponseModel;
  dateInformation: IBaseDateInformationResponseModel;
  manufacturingInformation: IBaseManufacturingInformationResponseModel;
  installedInformation: IBaseInstalledInformationResponseModel;
  furtherInformation: IBaseFurtherInformationResponseModel;
  gpsInformation: IBaseGpsInformationResponseModel;
  partnerInformation: IBasePartnerInformationResponseModel[] | null;
  hierarchyInformation: IBaseHierarchyInformationResponseModel;
  attributes: IBaseAttributesResponseModel[] | null;
  foreignSystems: IBaseForeignSystemsResponseModel[] | null;
  contactPersons: IBaseContactPersonsResponseModel[] | null;
  attachments: IBaseAttachmentResponseModel[] | null;
  history: IBaseHistory;
}

export interface IBaseFilterRequestModel {
  id: number;
  name: string | null;
  value: string | null;
}

export interface IBaseFilterResponseModel {
  id: number;
  name: string | null;
  value: string | null;
}

export interface IBaseFilterResponseModelBaseResultResponseModel {
  data: IBaseFilterResponseModel;
  links: LinksResponseModel;
}

export interface IBaseFilterResponseModelIEnumerableBaseResultResponseModel {
  data: IBaseFilterResponseModel[] | null;
  links: LinksResponseModel;
}

export interface IBaseForeignSystemValueModel {
  statusObject: { [key: string]: string } | null;
  type: { [key: string]: string } | null;
}

export interface IBaseForeignSystemsRequestModel {
  status: string | null;
  title: string | null;
  type: string | null;
  foreignSystem: string | null;
  foreignNumber: string | null;
  siemensPlantId: string | null;
}

export interface IBaseForeignSystemsResponseModel {
  status: string | null;
  type: string | null;
  link: string | null;
  foreignSystemId: string | null;
  foreignNumber: string | null;
  siemensPlantId: string | null;
  registrationDate: Date | null;
}

export interface IBaseFurtherInformationRequestModel {
  initialInternalProjectId: string | null;
  initialExternalProjectId: string | null;
  territoryStructureOperational: string | null;
  territoryStructureSales: string | null;
  batchNumber: string | null;
  timezone: string | null;
  remoteServiceFirst: boolean | null;
  sparesOnWebPartType: string | null;
  multiComponentPackage: boolean | null;
}

export interface IBaseFurtherInformationResponseModel {
  initialInternalProjectId: string | null;
  initialExternalProjectId: string | null;
  territoryStructureOperational: string | null;
  territoryStructureSales: string | null;
  batchNumber: string | null;
  timezone: string | null;
  remoteServiceFirst: boolean | null;
  sparesOnWebPartType: string | null;
  multiComponentPackage: boolean | null;
}

export interface IBaseFurtherRelationRequestModel {
  id: number;
  relationType: IBaseRelationType;
}

export interface IBaseFurtherRelationResponseModel {
  id: number | null;
  status: string | null;
  classification: string | null;
  name: string | null;
  relationType: IBaseRelationType;
  uniqueIdentifier: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  quantity: number | null;
}

export interface IBaseFurtherRelationResponseModelBasePaginatedResultResponseModel {
  data: IBaseFurtherRelationResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface IBaseGeneralInformationRequestModel {
  status: string | null;
  lifeCycleStatus: string | null;
  dataQuality: string | null;
  dataOrigin: string | null;
  spatialAssetType: string | null;
  spatialAssetSubType: string | null;
  commercialAssetType: string | null;
  componentType: string | null;
  subComponentType: string | null;
  technicalAssetType: string | null;
}

export interface IBaseGeneralInformationResponseModel {
  status: string | null;
  lifeCycleStatus: string | null;
  dataQuality: string | null;
  dataOrigin: string | null;
  spatialAssetType: string | null;
  spatialAssetSubType: string | null;
  commercialAssetType: string | null;
  componentType: string | null;
  subComponentType: string | null;
  technicalAssetType: string | null;
}

export interface IBaseGpsInformationRequestModel {
  latitude: string | null;
  longitude: string | null;
  altitude: string | null;
  gpsQuality: string | null;
  geolocationDescription: string | null;
}

export interface IBaseGpsInformationResponseModel {
  latitude: string | null;
  longitude: string | null;
  altitude: string | null;
  gpsQuality: string | null;
  geolocationDescription: string | null;
}

export interface IBaseHierarchyChildInformationRequestModel {
  id: number | null;
  refIdParentIBase: number | null;
  status: string | null;
  classification: string | null;
  name: string | null;
  uniqueIdentifier: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  quantity: number | null;
}

export interface IBaseHierarchyChildInformationResponseModel {
  id: number | null;
  refIdParentIBase: number | null;
  status: string | null;
  classification: string | null;
  lifeCycleStatus: string | null;
  name: string | null;
  uniqueIdentifier: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  quantity: number | null;
}

export interface IBaseHierarchyDescendantItemResponseModel {
  id: number | null;
  refID_ParentIBase: number | null;
  classification: string | null;
  componentClass: string | null;
  name: string | null;
  role: string | null;
  facilityNameInt: string | null;
  siteNameInt: string | null;
  typeOfCommercialAsset: string | null;
  typeOfSpatialAsset: string | null;
  typeOfTecnicalAsset: string | null;
}

export interface IBaseHierarchyDescendantsResponseModel {
  parentIBase: number;
  offset: number;
  elements: number;
  matchedCount: number;
  descendants: IBaseHierarchyDescendantItemResponseModel[] | null;
}

export interface IBaseHierarchyDescendantsResponseModelBaseResultResponseModel {
  data: IBaseHierarchyDescendantsResponseModel;
  links: LinksResponseModel;
}

export interface IBaseHierarchyInformationRequestModel {
  parent: IBaseHierarchyParentInformationRequestModel;
  childs: IBaseHierarchyChildInformationRequestModel[] | null;
}

export interface IBaseHierarchyInformationResponseModel {
  parent: IBaseHierarchyParentInformationResponseModel;
  childs: IBaseHierarchyChildInformationResponseModel[] | null;
}

export interface IBaseHierarchyParentInformationRequestModel {
  id: number | null;
  msgId: string | null;
  name: string | null;
  country: string | null;
  facilityName: string | null;
  role: string | null;
  streetInt: string | null;
  zipCode: string | null;
  cityInt: string | null;
  classification: string | null;
  typeOfCommercialAsset: string | null;
  typeOfSpatialAsset: string | null;
  typeOfTechnicalAsset: string | null;
  componentClass: string | null;
}

export interface IBaseHierarchyParentInformationResponseModel {
  id: number | null;
  name: string | null;
  country: string | null;
  facilityName: string | null;
  role: string | null;
  streetInt: string | null;
  zipCode: string | null;
  city: string | null;
  classification: string | null;
  typeOfCommercialAsset: string | null;
  typeOfSpatialAsset: string | null;
  typeOfTechnicalAsset: string | null;
  componentClass: string | null;
}

export interface IBaseHierarchyResponseModel {
  id: number | null;
  refID_ParentIBase: number | null;
  classification: string | null;
  componentClass: string | null;
  name: string | null;
  role: string | null;
  facilityNameInt: string | null;
  siteNameInt: string | null;
  typeOfCommercialAsset: string | null;
  typeOfSpatialAsset: string | null;
  typeOfTecnicalAsset: string | null;
  ancestors: IBaseHierarchyResponseModel[] | null;
}

export interface IBaseHierarchyResponseModelBaseResultResponseModel {
  data: IBaseHierarchyResponseModel;
  links: LinksResponseModel;
}

export interface IBaseHistory {
  createdAt: Date | null;
  lastChangedAt: Date | null;
}

export interface IBaseHistoryRequestModel {
  createdAt: Date | null;
  lastChangedAt: Date | null;
}

export interface IBaseIdentifierAndOrganizationalInformationRequestModel {
  uniqueIdentifier: string | null;
  uniqueIdentifierType: string | null;
  gck: string | null;
  depthStructure: string | null;
  productFamily: string | null;
  mainPurposeGroup: string | null;
  mainProductGroup: string | null;
  options: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  idLink: string | null;
  quantity: number | null;
  unitOfMeasure: string | null;
  yOptions: GibOptionsRequestModel[] | null;
}

export interface IBaseIdentifierAndOrganizationalInformationResponseModel {
  uniqueIdentifier: string | null;
  uniqueIdentifierType: string | null;
  gck: string | null;
  depthStructure: string | null;
  productFamily: string | null;
  mainPurposeGroup: string | null;
  mainProductGroup: string | null;
  options: string | null;
  productNumber: string | null;
  productNumberType: string | null;
  unitOfMeasure: string | null;
  serialNumber: string | null;
  idLink: string | null;
  quantity: number | null;
  yOptions: GibOptionResponseModel[] | null;
}

export interface IBaseInstalledInformationRequestModel {
  hardwareVersion: string | null;
  firmwareVersion: string | null;
  softwareVersion: string | null;
  referenceDesignation: string | null;
  mainVersionDescription: string | null;
  mainVersionType: string | null;
}

export interface IBaseInstalledInformationResponseModel {
  hardwareVersion: string | null;
  firmwareVersion: string | null;
  softwareVersion: string | null;
  referenceDesignation: string | null;
  mainVersionDescription: string | null;
  mainVersionType: string | null;
}

export interface IBaseManufacturingInformationRequestModel {
  siemensPlantId: string | null;
  thirdPartyProduct: boolean | null;
  thirdPartyManufacturer: string | null;
  thirdPartyProductName: string | null;
}

export interface IBaseManufacturingInformationResponseModel {
  siemensPlantId: string | null;
  thirdPartyProduct: boolean | null;
  thirdPartyManufacturer: string | null;
  thirdPartyProductName: string | null;
}

export interface IBasePartnerInformationRequestModel {
  id: number | null;
  msgId: string | null;
  currentlyInstalledFlag: boolean | null;
  currentlyResponsibleFlag: boolean | null;
  partnerTechnicalName: string | null;
  partnerTechnicalNumber: string | null;
  country: string | null;
  refIdIBase: number | null;
  refMsgIdIBase: string | null;
  refIdSite: number | null;
  role: string | null;
  status: string | null;
  facilityType: string | null;
  facilityAccountType: string | null;
  facilityTypeOfSite: string | null;
  facilityAddressType: string | null;
  facilityStatus: string | null;
  facilityName: string | null;
  facilityCity: string | null;
  facilityStreet: string | null;
  facilityZipCode: string | null;
  facilityCountry: string | null;
}

export interface IBasePartnerInformationResponseModel {
  id: number | null;
  msgId: string | null;
  partnerTechnicalName: string | null;
  partnerTechnicalNumber: string | null;
  country: string | null;
  refIdIBase: number | null;
  idPartner: number | null;
  refIdSite: number | null;
  role: string | null;
  status: string | null;
  dataQuality: string | null;
  facilityName: string | null;
  facilityCountry: string | null;
  facilityStreet: string | null;
  facilityZipCode: string | null;
  facilityCity: string | null;
  facilityType: string | null;
  facilityAccountType: string | null;
  facilityTypeOfSite: string | null;
  facilityAddressType: string | null;
  facilityStatus: string | null;
}

export enum IBaseRelationType {
  Contains = "Contains",
  ContainedIn = "ContainedIn",
}

export interface IBaseResponseModel {
  id: string | null;
  name: string | null;
  classification: string | null;
  isCached: boolean;
  details: IBaseDetailsResponseModel;
}

export interface IBaseResponseModelBaseResultResponseModel {
  data: IBaseResponseModel;
  links: LinksResponseModel;
}

export interface IBaseValueModel {
  attributeTypes: { [key: string]: string } | null;
  uniqueIdentifierTypes: { [key: string]: string } | null;
  typeOfCommercialAssets: { [key: string]: string } | null;
  typeOfSpatialAssets: { [key: string]: string } | null;
  statusLifeCycles: { [key: string]: string } | null;
  componentClasses: { [key: string]: string } | null;
  statusObjects: { [key: string]: string } | null;
  classifications: { [key: string]: string } | null;
  typeOfTechnicalAssets: { [key: string]: string } | null;
  qualityIndicators: { [key: string]: string } | null;
  labellingSystems: { [key: string]: string } | null;
  subtypeOfSpatialAssets: { [key: string]: string } | null;
  unitOfMeasures: { [key: string]: string } | null;
}

export enum IngestStatus {
  Success = "Success",
  Error = "Error",
}

export enum IngestType {
  Update = "Update",
  Creation = "Creation",
}

export interface IngestionNotificationResponseModel {
  id: number;
  userId: number;
  unread: boolean;
  objectType: ObjectType;
  ingestType: IngestType;
  ingestStatus: IngestStatus;
  objectId: string | null;
  objectName: string | null;
  eventId: string | null;
  processedAt: Date;
  createdAt: Date;
}

export interface IngestionNotificationResponseModelListBaseResultResponseModel {
  data: IngestionNotificationResponseModel[] | null;
  links: LinksResponseModel;
}

export interface LinksResponseModel {
  self: string | null;
}

export interface MainPurposeGroupResponseModel {
  id: number;
  purposeGroup: string | null;
  parentPurposeGroup: string | null;
  path: string | null;
  title: string | null;
  relevantForSma: boolean;
  lastChangeTimestamp: Date;
  readonly label: string | null;
}

export interface MainPurposeGroupResponseModelIListBaseResultResponseModel {
  data: MainPurposeGroupResponseModel[] | null;
  links: LinksResponseModel;
}

export interface MaintenanceGroupResponseModel {
  id: number;
  identifier: string | null;
  facility: number | null;
  country: string | null;
  territoryStructureOperational: string | null;
  status: string | null;
  isDefault: boolean;
  responsibleForDataSource: string | null;
  depthStructure: string | null;
  gck: string | null;
  phs: string | null;
  title: string | null;
  lastChangeTimestamp: Date;
  creationTimestamp: Date;
  readonly label: string | null;
}

export interface MaintenanceGroupResponseModelIListBaseResultResponseModel {
  data: MaintenanceGroupResponseModel[] | null;
  links: LinksResponseModel;
}

export interface MarkIngestionNotificationsAsReadRequestModel {
  notificationIds: number[];
}

export interface MetaResponseModel {
  page: PageResponseModel;
}

export interface ObjectInterlockResponseModel {
  id: number;
  lockedAt: Date | null;
  lockedBy: number;
  type: ObjectInterlockType;
}

export interface ObjectInterlockResponseModelBaseResultResponseModel {
  data: ObjectInterlockResponseModel;
  links: LinksResponseModel;
}

export enum ObjectInterlockType {
  IBase = "IBase",
  Facility = "Facility",
}

export enum ObjectType {
  IBase = "IBase",
  Facility = "Facility",
}

export interface OneLineFacilityResponseModel {
  statusObject: string | null;
  id: string | null;
  type: string | null;
  addressType: string | null;
  typeOfSite: string | null;
  accountType: string | null;
  name: string | null;
  streetInt: string | null;
  cityInt: string | null;
  country: string | null;
}

export interface OneLineFacilitySearchResponseModel {
  id: number | null;
  facilityType: string | null;
  facilityAccountType: string | null;
  facilityStatus: string | null;
  facilityAddressType: string | null;
  facilityTypeOfSite: string | null;
  siteName: string | null;
  facilityName: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
  zipCode: string | null;
}

export interface OneLineFacilitySearchResponseModelBasePaginatedResultResponseModel {
  data: OneLineFacilitySearchResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface OneLineFircResponseModel {
  currentlyInstalledFlag: boolean | null;
  currentlyResponsibleFlag: boolean | null;
  partnerTechnicalNumber: string | null;
  partnerTechnicalName: string | null;
  country: string | null;
  id: string | null;
  role: string | null;
  refIdIBase: string | null;
  refIdSite: string | null;
}

export interface OneLineIBaseResponseModel {
  statusObject: string | null;
  classification: string | null;
  typeOfCommercialAsset: string | null;
  typeOfSpatialAsset: string | null;
  typeOfTechnicalAsset: string | null;
  componentClass: string | null;
  id: string | null;
  name: string | null;
  uniqueIdentifier: string | null;
  uniqueIdentifierType: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  fircs: OneLineFircResponseModel[] | null;
}

export interface OneLineSearchIBaseResponseModel {
  iBases: OneLineIBaseResponseModel[] | null;
  facilities: OneLineFacilityResponseModel[] | null;
}

export interface OneLineSearchIBaseResponseModelBasePaginatedResultResponseModel {
  data: OneLineSearchIBaseResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface OperationalFacilityInformationRequestModel {
  facilityNameInt: string | null;
  facilityNameNat: string | null;
  alias: string | null;
  searchCriteriaFacility: string | null;
  industryClassification: string | null;
  verticalMarket: string | null;
  orgId: string | null;
  ifa: string | null;
  duns: string | null;
  businessPartnerId: string | null;
  standardAccountRole: string | null;
  governmentalBusiness: string | null;
  vatId: string | null;
  nationalTradeRegisterId: string | null;
  salesPotential: number | null;
  salesPotentialCategory: string | null;
}

export interface OperationalFacilityInformationResponseModel {
  facilityNameInt: string | null;
  facilityNameNat: string | null;
  alias: string | null;
  searchCriteriaFacility: string | null;
  industryClassification: string | null;
  verticalMarket: string | null;
  orgId: string | null;
  ifa: string | null;
  duns: string | null;
  businessPartnerId: string | null;
  standardAccountRole: string | null;
  governmentalBusiness: string | null;
  vatId: string | null;
  nationalTradeRegisterId: string | null;
  salesPotential: number | null;
  salesPotentialCategory: string | null;
}

export interface PageResponseModel {
  totalElements: number;
  offset: number;
  elements: number;
}

export interface PaginatedLinksResponseModel {
  self: string | null;
  next: string | null;
  last: string | null;
}

export interface PckResponseModel {
  nkPck: string | null;
  nkGck: string | null;
  description: string | null;
  readonly label: string | null;
}

export interface PckResponseModelIListBaseResultResponseModel {
  data: PckResponseModel[] | null;
  links: LinksResponseModel;
}

export interface PlantIdResponseModel {
  id: number;
  plant: string | null;
  country: string | null;
  facility: number | null;
  statusObject: string | null;
  foreignSystem: string | null;
  city: string | null;
  plantDescription: string | null;
  title: string | null;
  lastChangeTimestamp: Date;
  creationTimestamp: Date;
}

export interface PlantIdResponseModelIListBaseResultResponseModel {
  data: PlantIdResponseModel[] | null;
  links: LinksResponseModel;
}

export interface ProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;

  [key: string]: any;
}

export interface ProductHierarchyResponseModel {
  billableElement: boolean | null;
  dataSource: string | null;
  elementSupportedExternally: boolean | null;
  lastChangeTimestamp: Date | null;
  matureElement: boolean | null;
  path: string | null;
  pathSearch: string | null;
  productGroupIDX6: string | null;
  relevantForProductFeedback: boolean | null;
  relatedBusinessUnit: string | null;
  relevantForSMA: boolean | null;
  title: string | null;
  attributeTemplate: string | null;
  gck: string | null;
  phs: string | null;
  phsParente: string | null;
  tsc: string | null;
  serviceRelevance: string | null;
  readonly label: string | null;
}

export interface ProductHierarchyResponseModelIListBaseResultResponseModel {
  data: ProductHierarchyResponseModel[] | null;
  links: LinksResponseModel;
}

export interface ResolveErrorFailedResponseModel {
  objectId: string;
  reason: string | null;
}

export interface ResolveErrorsRequestModel {
  objectIds: string[];
}

export interface ResolveErrorsResponseModel {
  resolved: string[] | null;
  failed: ResolveErrorFailedResponseModel[] | null;
}

export interface ResolveErrorsResponseModelBaseResultResponseModel {
  data: ResolveErrorsResponseModel;
  links: LinksResponseModel;
}

export interface RoleResponseModel {
  id: number;
  roleType: RoleType;
  description: string | null;
}

export interface RoleResponseModelListBaseResultResponseModel {
  data: RoleResponseModel[] | null;
  links: LinksResponseModel;
}

export enum RoleType {
  Sibasex_user = "sibasex_user",
  Data_maintainer = "data_maintainer",
  User_manager = "user_manager",
  Maintenance_group_manager = "maintenance_group_manager",
  Valuelist_manager = "valuelist_manager",
  Application_manager = "application_manager",
  Error_maintainer = "error_maintainer",
}

export interface ScdPeopleApiContentResponseModel {
  peoples: ScdPeopleApiResponseModel[] | null;
}

export interface ScdPeopleApiContentResponseModelBaseResultResponseModel {
  data: ScdPeopleApiContentResponseModel;
  links: LinksResponseModel;
}

export interface ScdPeopleApiResponseModel {
  country: string | null;
  department: string | null;
  email: string | null;
  gid: string | null;
  givenName: string | null;
  lastName: string | null;
}

export interface SearchFacilityConnectedAssetsModel {
  classification: string | null;
  customerRole: string | null;
  equipmentName: string | null;
  equipmentNumber: string | null;
  productNumber: string | null;
  serialNumber: string | null;
}

export interface SearchFacilityDetailFieldsModel {
  ifa: string | null;
  duns: string | null;
  internalOrgId: string | null;
  industryClassification: string | null;
  verticalMarket: string | null;
}

export interface SearchFacilityForeignSystemsModel {
  foreignSystemId: string | null;
  foreignNumberOfFacility: string | null;
}

export interface SearchFacilityMainFieldsModel {
  status: string | null;
  siBaseId: number | null;
  type: string | null;
  accountType: string | null;
  siteName: string | null;
  country: string | null;
  city: string | null;
  street: string | null;
}

export interface SearchFacilityRequestModel {
  offset: number | null;
  elements: number | null;
  mainFields: SearchFacilityMainFieldsModel;
  detailFields: SearchFacilityDetailFieldsModel;
  siteDetails: SearchFacilitySiteDetailsModel;
  foreignSystems: SearchFacilityForeignSystemsModel;
  connectedAssets: SearchFacilityConnectedAssetsModel;
}

export interface SearchFacilitySiteDetailsModel {
  typeOfSite: string | null;
  searchCriteriaSite: string | null;
  subnationalUnit: string | null;
  territoryStructureOperational: string | null;
  email: string | null;
  homepage: string | null;
}

export interface SearchIBaseDetailFieldsRequestModel {
  typeOfCommercialAsset: string | null;
  componentClassification: string | null;
  typeOfTechnicalAsset: string | null;
  typeOfSpatialAsset: string | null;
  subtypeOfSpatialAsset: string | null;
  lifecycleStatus: string | null;
  typeOfUniqueIdentifier: string | null;
  creationTimestamp: Date | null;
  lastChangeTimestamp: Date | null;
}

export interface SearchIBaseFacilityRequestModel {
  id: number | null;
  facilityNameInt: string | null;
  facilityCountry: string | null;
  facilityCity: string | null;
}

export interface SearchIBaseForeignSystemsRequestModel {
  iBaseNumber: string | null;
  foreignSystemId: string | null;
}

export interface SearchIBaseMainFieldsRequestModel {
  status: string | null;
  siBaseId: number | null;
  classification: string | null;
  technicalNumber: string | null;
  technicalName: string | null;
  productNumber: string | null;
  serialNumber: string | null;
  uniqueIdentifier: string | null;
  mainProductGroup: string | null;
  mainPurposeGroup: string | null;
  assetName: string | null;
  dataOrigin: string | null;
}

export interface SearchIBaseRequestModel {
  offset: number;
  elements: number;
  mainFields: SearchIBaseMainFieldsRequestModel;
  detailFields: SearchIBaseDetailFieldsRequestModel;
  foreignSystems: SearchIBaseForeignSystemsRequestModel;
  facilityFields: SearchIBaseFacilityRequestModel;
}

export interface SearchIBaseResponseModel {
  serialNumber: string | null;
  id: string | null;
  status: string | null;
  technicalNumber: string | null;
  classification: string | null;
  partnerRole: string | null;
  productNumber: string | null;
  technicalName: string | null;
  uniqueIdentifier: string | null;
  name: string | null;
}

export interface SearchIBaseResponseModelBasePaginatedResultResponseModel {
  data: SearchIBaseResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface SearchIncludesRequestModel {
  attachment: boolean | null;
  facility: boolean | null;
  firc: boolean | null;
  iBase: boolean | null;
}

export enum SearchSettingsSortOrderEnumRequestModel {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum SearchStrategy {
  StrictWithFuzzySeparation = "StrictWithFuzzySeparation",
  StrictWithFuzzyInclusionMostMatches = "StrictWithFuzzyInclusionMostMatches",
  StrictWithFuzzyInclusionBestMatch = "StrictWithFuzzyInclusionBestMatch",
  StrictWithFuzzyTerms = "StrictWithFuzzyTerms",
}

export interface SisicResponseModel {
  id: number;
  sisicCode: string | null;
  parentSisicCode: string | null;
  vertical: string | null;
  isicDetail: string | null;
  lastChangeTimestamp: Date;
  readonly label: string | null;
}

export interface SisicResponseModelIListBaseResultResponseModel {
  data: SisicResponseModel[] | null;
  links: LinksResponseModel;
}

export interface SiteInformationRequestModel {
  siteNameInt: string | null;
  siteNameNat: string | null;
  searchCriteriaSite: string | null;
  siteDescription: string | null;
}

export interface SiteInformationResponseModel {
  siteNameInt: string | null;
  siteNameNat: string | null;
  searchCriteriaSite: string | null;
  siteDescription: string | null;
}

export interface SubNationalUnitResponseModel {
  id: number;
  lastChangeTimestamp: Date;
  remark: { [key: string]: string } | null;
  timeZones: string[] | null;
  title: { [key: string]: string } | null;
  country: string | null;
  status: string | null;
  subNationalUnits: string | null;
}

export interface SubNationalUnitResponseModelIListBaseResultResponseModel {
  data: SubNationalUnitResponseModel[] | null;
  links: LinksResponseModel;
}

export interface TerritoryStructureOperationalResponseModel {
  id: number;
  lastChangeTimestamp: Date;
  name: string | null;
  postalCodeRanges: string | null;
  title: string | null;
  country: string | null;
  territoryStructureOperational: string | null;
  readonly label: string | null;
}

export interface TerritoryStructureOperationalResponseModelIListBaseResultResponseModel {
  data: TerritoryStructureOperationalResponseModel[] | null;
  links: LinksResponseModel;
}

export interface TimezoneMetadataResponseModel {
  id: string | null;
  title: string | null;
  abreviation: string | null;
  location: string | null;
  description: string | null;
  msIndex: number | null;
  msTitle: string | null;
  locked: boolean | null;
  isDsi: boolean | null;
  supportSdsi: boolean | null;
  updated: boolean | null;
  utcOffset: string | null;
  utcOffsetFloat: number | null;
  lastChangeTimestamp: Date;
  readonly label: string | null;
}

export interface TimezoneMetadataResponseModelIListBaseResultResponseModel {
  data: TimezoneMetadataResponseModel[] | null;
  links: LinksResponseModel;
}

export interface UpdateCompanyRoleRequestModel {
  contactRole: string | null;
  customerRole: boolean;
  defaultIbaseRole: boolean;
  title: { [key: string]: string };
  validForStandardCompanyRole: boolean;
  statusObject: string;
}

export interface UpdateContactRoleRequestModel {
  companyRole: string[] | null;
  title: { [key: string]: string };
  statusObject: string;
}

export interface UpdateCountryRequestModel {
  title: { [key: string]: string };
  status: string | null;
  currency: string | null;
  continent: string | null;
  countryCharacteristic: string | null;
  language: string | null;
  leadCountry: string | null;
  summerTimeStart: string | null;
  summerTimeEnd: string | null;
  timeZoneTitle: string | null;
  additionalOffset: number;
  comments: string | null;
  codeInternational: string | null;
  criticalForEcc: boolean;
  noAutomatedSetOfAwvCode: boolean;
  poRequestNotAllowed: boolean;
  streetZipCodeRule: string | null;
  subNationalUnitsAvailable: boolean | null;
  territoryStructureOperationalAvailable: boolean;
  valuableCompanyThreshold: number;
  minZipCode: string | null;
  insertPosition: string | null;
  insertionString: string | null;
  numberOfFactTitleFields: string | null;
  zipCodeRuleDescription: { [key: string]: string } | null;
  errorMessage: { [key: string]: string } | null;
  remarks: { [key: string]: string } | null;
  warning1: { [key: string]: string } | null;
  warning2: { [key: string]: string } | null;
  countryGroup: number | null;
  patacAuditCycle: number | null;
  patacChangeDate: Date | null;
  patacEmailAddress: string | null;
  patacDescription: string | null;
  patacId: string | null;
  patacSetBy: string | null;
  patacTestResult: string | null;
  patacValidFrom: Date | null;
  patacValidTo: Date | null;
}

export interface UpdateErrorFilterRequestModel {
  name: string | null;
  value: string | null;
  id: number;
}

export interface UpdateFacilityRequestModel {
  type: FacilityType;
  facilityDetails: FacilityDetailsRequestModel;
  id: number;
}

export interface UpdateForeignSystemRequestModel {
  foreignSystemName: string;
  statusObject: string;
  type: string;
  remoteAccessDeviceType: string | null;
  systemCountry: string | null;
  systemUrl: string | null;
  title: string | null;
  mandt: string | null;
  sysId: string | null;
  isAssetConnectorSystem: boolean;
  isCheckAgainstHana: boolean;
  isDeliverEdDataSystem: boolean;
  isErp: boolean;
  isFsErp: boolean;
  isLsaMandatoryForErp: boolean;
  isRelevantForIBase: boolean;
  isRelevantForPerson: boolean;
  isRemoteAccessSystem: boolean;
  isUniqueInIBase: boolean;
  isUpdateFlag: boolean;
  isUserRelevant: boolean;
  isForeignIdUnique: boolean | null;
}

export interface UpdateIBaseRequestModel {
  name: string | null;
  classification: IBaseClassification;
  details: IBaseDetailsRequestModel;
  id: number;
}

export interface UpdateTopicDisplayNameRequestModel {
  displayName: string | null;
}

export interface UpdateTopicDisplayNameResponseModel {
  id: number;
  topicName: string | null;
  displayName: string | null;
  lastModifiedAt: Date | null;
  lastModifiedBy: number | null;
}

export interface UpdateTopicDisplayNameResponseModelBaseResultResponseModel {
  data: UpdateTopicDisplayNameResponseModel;
  links: LinksResponseModel;
}

export enum UserHistoryActionType {
  Added = "Added",
  Removed = "Removed",
}

export interface UserManagementCreateRequestModel {
  gid: string | null;
  roles: RoleType[] | null;
}

export interface UserManagementHistoryPagedResponseModel {
  metaResponseModel: MetaResponseModel;
  manageHistory: UserManagementHistoryResponseModel;
}

export interface UserManagementHistoryPagedResponseModelBaseResultResponseModel {
  data: UserManagementHistoryPagedResponseModel;
  links: LinksResponseModel;
}

export interface UserManagementHistoryRecordResponseModel {
  timeOffset: Date;
  roleType: RoleType;
  userHistoryActionType: UserHistoryActionType;
  modifiedBy: UserManagementUserHistoryResponseModel;
}

export interface UserManagementHistoryResponseModel {
  lastChange: Date | null;
  lastChangeBy: UserManagementUserHistoryResponseModel;
  createdBy: UserManagementUserHistoryResponseModel;
  createdOn: Date;
  history: UserManagementHistoryRecordResponseModel[] | null;
}

export interface UserManagementResponseModel {
  user: UserResponseModel;
  roles: RoleResponseModel[] | null;
}

export interface UserManagementResponseModelBasePaginatedResultResponseModel {
  data: UserManagementResponseModel[] | null;
  links: PaginatedLinksResponseModel;
  meta: MetaResponseModel;
}

export interface UserManagementResponseModelBaseResultResponseModel {
  data: UserManagementResponseModel;
  links: LinksResponseModel;
}

export interface UserManagementUpdateRequestModel {
  gid: string | null;
  roles: RoleType[] | null;
}

export interface UserManagementUserHistoryResponseModel {
  firstName: string | null;
  lastName: string | null;
}

export interface UserResponseModel {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  gid: string | null;
  department: string | null;
  streetAddress: string | null;
  postalCode: string | null;
  city: string | null;
  displayName: string | null;
  country: string | null;
  isProtected: boolean;
  lastLoginDate: Date | null;
}

export interface UserResponseModelBaseResultResponseModel {
  data: UserResponseModel;
  links: LinksResponseModel;
}

export interface ValidationProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
  errors: { [key: string]: string[] } | null;

  [key: string]: any;
}

export interface ValuelistAndDropdownNamesResponseModel {
  valuelists: ValuelistNameResponseModel[] | null;
  dropdownObjectTypes: string[] | null;
}

export interface ValuelistAndDropdownNamesResponseModelBaseResultResponseModel {
  data: ValuelistAndDropdownNamesResponseModel;
  links: LinksResponseModel;
}

export interface ValuelistNameResponseModel {
  topicName: string | null;
  displayName: string | null;
}

export interface VerticalResponseModel {
  isDefault: boolean;
  lastChangeTimestamp: Date;
  path: string | null;
  title: string | null;
  parent: string | null;
  customerRole: string | null;
  verticalCode: string | null;
  readonly label: string | null;
}

export interface VerticalResponseModelIListBaseResultResponseModel {
  data: VerticalResponseModel[] | null;
  links: LinksResponseModel;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
